!(function (t) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = t();
    else if ("function" == typeof define && define.amd) define([], t);
    else {
        var e;
        ("undefined" != typeof window
            ? (e = window)
            : "undefined" != typeof global
              ? (e = global)
              : "undefined" != typeof self && (e = self),
            (e.Quill = t()));
    }
})(function () {
    return (function t(e, n, i) {
        function r(s, l) {
            if (!n[s]) {
                if (!e[s]) {
                    var u = "function" == typeof require && require;
                    if (!l && u) return u(s, !0);
                    if (o) return o(s, !0);
                    var a = new Error("Cannot find module '" + s + "'");
                    throw ((a.code = "MODULE_NOT_FOUND"), a);
                }
                var c = (n[s] = { exports: {} });
                e[s][0].call(
                    c.exports,
                    function (t) {
                        var n = e[s][1][t];
                        return r(n || t);
                    },
                    c,
                    c.exports,
                    t,
                    e,
                    n,
                    i
                );
            }
            return n[s].exports;
        }
        for (var o = "function" == typeof require && require, s = 0; s < i.length; s++) r(i[s]);
        return r;
    })(
        {
            1: [
                function (t, e, n) {
                    (function (t) {
                        (function () {
                            function i(t, e, n) {
                                for (var i = (n || 0) - 1, r = t ? t.length : 0; ++i < r; )
                                    if (t[i] === e) return i;
                                return -1;
                            }
                            function r(t, e) {
                                var n = typeof e;
                                if (((t = t.cache), "boolean" == n || null == e)) return t[e] ? 0 : -1;
                                "number" != n && "string" != n && (n = "object");
                                var r = "number" == n ? e : H + e;
                                return (
                                    (t = (t = t[n]) && t[r]),
                                    "object" == n ? (t && i(t, e) > -1 ? 0 : -1) : t ? 0 : -1
                                );
                            }
                            function o(t) {
                                var e = this.cache,
                                    n = typeof t;
                                if ("boolean" == n || null == t) e[t] = !0;
                                else {
                                    "number" != n && "string" != n && (n = "object");
                                    var i = "number" == n ? t : H + t,
                                        r = e[n] || (e[n] = {});
                                    "object" == n ? (r[i] || (r[i] = [])).push(t) : (r[i] = !0);
                                }
                            }
                            function s(t) {
                                var e = -1,
                                    n = t.length,
                                    i = t[0],
                                    r = t[(n / 2) | 0],
                                    s = t[n - 1];
                                if (
                                    i &&
                                    "object" == typeof i &&
                                    r &&
                                    "object" == typeof r &&
                                    s &&
                                    "object" == typeof s
                                )
                                    return !1;
                                var l = u();
                                l.false = l.null = l.true = l.undefined = !1;
                                var a = u();
                                for (a.array = t, a.cache = l, a.push = o; ++e < n; ) a.push(t[e]);
                                return a;
                            }
                            function l() {
                                return j.pop() || [];
                            }
                            function u() {
                                return (
                                    B.pop() || {
                                        array: null,
                                        cache: null,
                                        false: !1,
                                        null: !1,
                                        number: null,
                                        object: null,
                                        push: null,
                                        string: null,
                                        true: !1,
                                        undefined: !1
                                    }
                                );
                            }
                            function a(t) {
                                ((t.length = 0), j.length < P && j.push(t));
                            }
                            function c(t) {
                                var e = t.cache;
                                (e && c(e),
                                    (t.array = t.cache = t.object = t.number = t.string = null),
                                    B.length < P && B.push(t));
                            }
                            function h(t, e, n) {
                                (e || (e = 0), void 0 === n && (n = t ? t.length : 0));
                                for (var i = -1, r = n - e || 0, o = Array(r < 0 ? 0 : r); ++i < r; )
                                    o[i] = t[e + i];
                                return o;
                            }
                            function f() {}
                            function p(t) {
                                function e() {
                                    if (i) {
                                        var t = h(i);
                                        gt.apply(t, arguments);
                                    }
                                    if (this instanceof e) {
                                        var o = g(n.prototype),
                                            s = n.apply(o, t || arguments);
                                        return S(s) ? s : o;
                                    }
                                    return n.apply(r, t || arguments);
                                }
                                var n = t[0],
                                    i = t[2],
                                    r = t[4];
                                return (At(e, t), e);
                            }
                            function d(t, e, n, i, r) {
                                if (n) {
                                    var o = n(t);
                                    if (void 0 !== o) return o;
                                }
                                if (!S(t)) return t;
                                var s = ht.call(t);
                                if (!et[s]) return t;
                                var u = xt[s];
                                switch (s) {
                                    case Y:
                                    case Z:
                                        return new u(+t);
                                    case Q:
                                    case tt:
                                        return new u(t);
                                    case J:
                                        return (
                                            (o = u(t.source, K.exec(t))),
                                            (o.lastIndex = t.lastIndex),
                                            o
                                        );
                                }
                                var c = Lt(t);
                                if (e) {
                                    var f = !i;
                                    (i || (i = l()), r || (r = l()));
                                    for (var p = i.length; p--; ) if (i[p] == t) return r[p];
                                    o = c ? u(t.length) : {};
                                } else o = c ? h(t) : Nt({}, t);
                                return (
                                    c &&
                                        (dt.call(t, "index") && (o.index = t.index),
                                        dt.call(t, "input") && (o.input = t.input)),
                                    e
                                        ? (i.push(t),
                                          r.push(o),
                                          (c ? C : qt)(t, function (t, s) {
                                              o[s] = d(t, e, n, i, r);
                                          }),
                                          f && (a(i), a(r)),
                                          o)
                                        : o
                                );
                            }
                            function g(t, e) {
                                return S(t) ? vt(t) : {};
                            }
                            function m(t, e, n) {
                                if ("function" != typeof t) return D;
                                if (void 0 === e || !("prototype" in t)) return t;
                                var i = t.__bindData__;
                                if (
                                    void 0 === i &&
                                    (Tt.funcNames && (i = !t.name), !(i = i || !Tt.funcDecomp))
                                ) {
                                    var r = pt.call(t);
                                    (Tt.funcNames || (i = !z.test(r)),
                                        i || ((i = V.test(r)), At(t, i)));
                                }
                                if (!1 === i || (!0 !== i && 1 & i[1])) return t;
                                switch (n) {
                                    case 1:
                                        return function (n) {
                                            return t.call(e, n);
                                        };
                                    case 2:
                                        return function (n, i) {
                                            return t.call(e, n, i);
                                        };
                                    case 3:
                                        return function (n, i, r) {
                                            return t.call(e, n, i, r);
                                        };
                                    case 4:
                                        return function (n, i, r, o) {
                                            return t.call(e, n, i, r, o);
                                        };
                                }
                                return O(t, e);
                            }
                            function y(t) {
                                function e() {
                                    var t = u ? s : this;
                                    if (r) {
                                        var d = h(r);
                                        gt.apply(d, arguments);
                                    }
                                    if (
                                        (o || c) &&
                                        (d || (d = h(arguments)),
                                        o && gt.apply(d, o),
                                        c && d.length < l)
                                    )
                                        return ((i |= 16), y([n, f ? i : -4 & i, d, null, s, l]));
                                    if ((d || (d = arguments), a && (n = t[p]), this instanceof e)) {
                                        t = g(n.prototype);
                                        var m = n.apply(t, d);
                                        return S(m) ? m : t;
                                    }
                                    return n.apply(t, d);
                                }
                                var n = t[0],
                                    i = t[1],
                                    r = t[2],
                                    o = t[3],
                                    s = t[4],
                                    l = t[5],
                                    u = 1 & i,
                                    a = 2 & i,
                                    c = 4 & i,
                                    f = 8 & i,
                                    p = n;
                                return (At(e, t), e);
                            }
                            function v(t, e) {
                                var n = -1,
                                    o = x(),
                                    l = t ? t.length : 0,
                                    u = l >= G && o === i,
                                    a = [];
                                if (u) {
                                    var h = s(e);
                                    h ? ((o = r), (e = h)) : (u = !1);
                                }
                                for (; ++n < l; ) {
                                    var f = t[n];
                                    o(e, f) < 0 && a.push(f);
                                }
                                return (u && c(e), a);
                            }
                            function b(t, e, n, i) {
                                for (var r = (i || 0) - 1, o = t ? t.length : 0, s = []; ++r < o; ) {
                                    var l = t[r];
                                    if (
                                        l &&
                                        "object" == typeof l &&
                                        "number" == typeof l.length &&
                                        (Lt(l) || A(l))
                                    ) {
                                        e || (l = b(l, e, n));
                                        var u = -1,
                                            a = l.length,
                                            c = s.length;
                                        for (s.length += a; ++u < a; ) s[c++] = l[u];
                                    } else n || s.push(l);
                                }
                                return s;
                            }
                            function E(t, e, n, i, r, o) {
                                if (n) {
                                    var s = n(t, e);
                                    if (void 0 !== s) return !!s;
                                }
                                if (t === e) return 0 !== t || 1 / t == 1 / e;
                                var u = typeof t,
                                    c = typeof e;
                                if (!(t !== t || (t && it[u]) || (e && it[c]))) return !1;
                                if (null == t || null == e) return t === e;
                                var h = ht.call(t),
                                    f = ht.call(e);
                                if ((h == X && (h = $), f == X && (f = $), h != f)) return !1;
                                switch (h) {
                                    case Y:
                                    case Z:
                                        return +t == +e;
                                    case Q:
                                        return t != +t ? e != +e : 0 == t ? 1 / t == 1 / e : t == +e;
                                    case J:
                                    case tt:
                                        return t == String(e);
                                }
                                var p = h == W;
                                if (!p) {
                                    var d = dt.call(t, "__wrapped__"),
                                        g = dt.call(e, "__wrapped__");
                                    if (d || g)
                                        return E(
                                            d ? t.__wrapped__ : t,
                                            g ? e.__wrapped__ : e,
                                            n,
                                            i,
                                            r,
                                            o
                                        );
                                    if (h != $) return !1;
                                    var m = t.constructor,
                                        y = e.constructor;
                                    if (
                                        m != y &&
                                        !(L(m) && m instanceof m && L(y) && y instanceof y) &&
                                        "constructor" in t &&
                                        "constructor" in e
                                    )
                                        return !1;
                                }
                                var v = !r;
                                (r || (r = l()), o || (o = l()));
                                for (var b = r.length; b--; ) if (r[b] == t) return o[b] == e;
                                var _ = 0;
                                if (((s = !0), r.push(t), o.push(e), p)) {
                                    if (((b = t.length), (_ = e.length), (s = _ == b) || i))
                                        for (; _--; ) {
                                            var x = b,
                                                T = e[_];
                                            if (i) for (; x-- && !(s = E(t[x], T, n, i, r, o)); );
                                            else if (!(s = E(t[_], T, n, i, r, o))) break;
                                        }
                                } else
                                    (Ct(e, function (e, l, u) {
                                        if (dt.call(u, l))
                                            return (_++, (s = dt.call(t, l) && E(t[l], e, n, i, r, o)));
                                    }),
                                        s &&
                                            !i &&
                                            Ct(t, function (t, e, n) {
                                                if (dt.call(n, e)) return (s = --_ > -1);
                                            }));
                                return (r.pop(), o.pop(), v && (a(r), a(o)), s);
                            }
                            function _(t, e, n, i, r, o) {
                                var s = 1 & e,
                                    l = 4 & e,
                                    u = 16 & e,
                                    a = 32 & e;
                                if (!(2 & e) && !L(t)) throw new TypeError();
                                (u && !n.length && ((e &= -17), (u = n = !1)),
                                    a && !i.length && ((e &= -33), (a = i = !1)));
                                var c = t && t.__bindData__;
                                return c && !0 !== c
                                    ? ((c = h(c))[2] && (c[2] = h(c[2])),
                                      c[3] && (c[3] = h(c[3])),
                                      !s || 1 & c[1] || (c[4] = r),
                                      !s && 1 & c[1] && (e |= 8),
                                      !l || 4 & c[1] || (c[5] = o),
                                      u && gt.apply(c[2] || (c[2] = []), n),
                                      a && mt.apply(c[3] || (c[3] = []), i),
                                      (c[1] |= e),
                                      _.apply(null, c))
                                    : (1 == e || 17 === e ? p : y)([t, e, n, i, r, o]);
                            }
                            function x() {
                                var t = (t = f.indexOf) === k ? i : t;
                                return t;
                            }
                            function T(t) {
                                return "function" == typeof t && ft.test(t);
                            }
                            function A(t) {
                                return (
                                    (t &&
                                        "object" == typeof t &&
                                        "number" == typeof t.length &&
                                        ht.call(t) == X) ||
                                    !1
                                );
                            }
                            function L(t) {
                                return "function" == typeof t;
                            }
                            function S(t) {
                                return !(!t || !it[typeof t]);
                            }
                            function N(t, e, n) {
                                var i = !0;
                                e = f.createCallback(e, n, 3);
                                var r = -1,
                                    o = t ? t.length : 0;
                                if ("number" == typeof o) for (; ++r < o && (i = !!e(t[r], r, t)); );
                                else
                                    qt(t, function (t, n, r) {
                                        return (i = !!e(t, n, r));
                                    });
                                return i;
                            }
                            function C(t, e, n) {
                                var i = -1,
                                    r = t ? t.length : 0;
                                if (((e = e && void 0 === n ? e : m(e, n, 3)), "number" == typeof r))
                                    for (; ++i < r && !1 !== e(t[i], i, t); );
                                else qt(t, e);
                                return t;
                            }
                            function q(t, e, n) {
                                var i = -1,
                                    r = t ? t.length : 0;
                                if (((e = f.createCallback(e, n, 3)), "number" == typeof r))
                                    for (var o = Array(r); ++i < r; ) o[i] = e(t[i], i, t);
                                else
                                    ((o = []),
                                        qt(t, function (t, n, r) {
                                            o[++i] = e(t, n, r);
                                        }));
                                return o;
                            }
                            function w(t, e, n, i) {
                                if (!t) return n;
                                var r = arguments.length < 3;
                                e = f.createCallback(e, i, 4);
                                var o = -1,
                                    s = t.length;
                                if ("number" == typeof s)
                                    for (r && (n = t[++o]); ++o < s; ) n = e(n, t[o], o, t);
                                else
                                    qt(t, function (t, i, o) {
                                        n = r ? ((r = !1), t) : e(n, t, i, o);
                                    });
                                return n;
                            }
                            function k(t, e, n) {
                                if ("number" == typeof n) {
                                    var r = t ? t.length : 0;
                                    n = n < 0 ? _t(0, r + n) : n || 0;
                                } else if (n) {
                                    var o = I(t, e);
                                    return t[o] === e ? o : -1;
                                }
                                return i(t, e, n);
                            }
                            function I(t, e, n, i) {
                                var r = 0,
                                    o = t ? t.length : r;
                                for (e = (n = n ? f.createCallback(n, i, 1) : D)(e); r < o; ) {
                                    var s = (r + o) >>> 1;
                                    n(t[s]) < e ? (r = s + 1) : (o = s);
                                }
                                return r;
                            }
                            function O(t, e) {
                                return arguments.length > 2
                                    ? _(t, 17, h(arguments, 2), null, e)
                                    : _(t, 1, null, null, e);
                            }
                            function D(t) {
                                return t;
                            }
                            function M() {}
                            function R(t) {
                                return function (e) {
                                    return e[t];
                                };
                            }
                            var U,
                                j = [],
                                B = [],
                                F = 0,
                                H = +new Date() + "",
                                G = 75,
                                P = 40,
                                K = /\w*$/,
                                z = /^\s*function[ \n\r\t]+\w/,
                                V = /\bthis\b/,
                                X = "[object Arguments]",
                                W = "[object Array]",
                                Y = "[object Boolean]",
                                Z = "[object Date]",
                                Q = "[object Number]",
                                $ = "[object Object]",
                                J = "[object RegExp]",
                                tt = "[object String]",
                                et = {};
                            ((et["[object Function]"] = !1),
                                (et[X] = et[W] = et[Y] = et[Z] = et[Q] = et[$] = et[J] = et[tt] = !0));
                            var nt = { configurable: !1, enumerable: !1, value: null, writable: !1 },
                                it = {
                                    boolean: !1,
                                    function: !0,
                                    object: !0,
                                    number: !1,
                                    string: !1,
                                    undefined: !1
                                },
                                rt = (it[typeof window] && window) || this,
                                ot = it[typeof n] && n && !n.nodeType && n,
                                st = it[typeof e] && e && !e.nodeType && e,
                                lt = st && st.exports === ot && ot,
                                ut = it[typeof t] && t;
                            !ut || (ut.global !== ut && ut.window !== ut) || (rt = ut);
                            var at = [],
                                ct = Object.prototype,
                                ht = ct.toString,
                                ft = RegExp(
                                    "^" +
                                        String(ht)
                                            .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
                                            .replace(/toString| for [^\]]+/g, ".*?") +
                                        "$"
                                ),
                                pt = Function.prototype.toString,
                                dt = ct.hasOwnProperty,
                                gt = at.push,
                                mt = at.unshift,
                                yt = (function () {
                                    try {
                                        var t = {},
                                            e = T((e = Object.defineProperty)) && e,
                                            n = e(t, t, t) && e;
                                    } catch (t) {}
                                    return n;
                                })(),
                                vt = T((vt = Object.create)) && vt,
                                bt = T((bt = Array.isArray)) && bt,
                                Et = T((Et = Object.keys)) && Et,
                                _t = Math.max,
                                xt = {};
                            ((xt[W] = Array),
                                (xt[Y] = Boolean),
                                (xt[Z] = Date),
                                (xt["[object Function]"] = Function),
                                (xt[$] = Object),
                                (xt[Q] = Number),
                                (xt[J] = RegExp),
                                (xt[tt] = String));
                            var Tt = (f.support = {});
                            ((Tt.funcDecomp =
                                !T(rt.WinRTError) &&
                                V.test(function () {
                                    return this;
                                })),
                                (Tt.funcNames = "string" == typeof Function.name),
                                vt ||
                                    (g = (function () {
                                        function t() {}
                                        return function (e) {
                                            if (S(e)) {
                                                t.prototype = e;
                                                var n = new t();
                                                t.prototype = null;
                                            }
                                            return n || rt.Object();
                                        };
                                    })()));
                            var At = yt
                                    ? function (t, e) {
                                          ((nt.value = e), yt(t, "__bindData__", nt));
                                      }
                                    : M,
                                Lt =
                                    bt ||
                                    function (t) {
                                        return (
                                            (t &&
                                                "object" == typeof t &&
                                                "number" == typeof t.length &&
                                                ht.call(t) == W) ||
                                            !1
                                        );
                                    },
                                St = Et
                                    ? function (t) {
                                          return S(t) ? Et(t) : [];
                                      }
                                    : function (t) {
                                          var e,
                                              n = t,
                                              i = [];
                                          if (!n) return i;
                                          if (!it[typeof t]) return i;
                                          for (e in n) dt.call(n, e) && i.push(e);
                                          return i;
                                      },
                                Nt = function (t, e, n) {
                                    var i,
                                        r = t,
                                        o = r;
                                    if (!r) return o;
                                    var s = arguments,
                                        l = 0,
                                        u = "number" == typeof n ? 2 : s.length;
                                    if (u > 3 && "function" == typeof s[u - 2])
                                        var a = m(s[--u - 1], s[u--], 2);
                                    else u > 2 && "function" == typeof s[u - 1] && (a = s[--u]);
                                    for (; ++l < u; )
                                        if ((r = s[l]) && it[typeof r])
                                            for (
                                                var c = -1,
                                                    h = it[typeof r] && St(r),
                                                    f = h ? h.length : 0;
                                                ++c < f;

                                            )
                                                o[(i = h[c])] = a ? a(o[i], r[i]) : r[i];
                                    return o;
                                },
                                Ct = function (t, e, n) {
                                    var i,
                                        r = t,
                                        o = r;
                                    if (!r) return o;
                                    if (!it[typeof r]) return o;
                                    e = e && void 0 === n ? e : m(e, n, 3);
                                    for (i in r) if (!1 === e(r[i], i, t)) return o;
                                    return o;
                                },
                                qt = function (t, e, n) {
                                    var i,
                                        r = t,
                                        o = r;
                                    if (!r) return o;
                                    if (!it[typeof r]) return o;
                                    e = e && void 0 === n ? e : m(e, n, 3);
                                    for (
                                        var s = -1, l = it[typeof r] && St(r), u = l ? l.length : 0;
                                        ++s < u;

                                    )
                                        if (((i = l[s]), !1 === e(r[i], i, t))) return o;
                                    return o;
                                };
                            ((f.assign = Nt),
                                (f.bind = O),
                                (f.createCallback = function (t, e, n) {
                                    var i = typeof t;
                                    if (null == t || "function" == i) return m(t, e, n);
                                    if ("object" != i) return R(t);
                                    var r = St(t),
                                        o = r[0],
                                        s = t[o];
                                    return 1 != r.length || s !== s || S(s)
                                        ? function (e) {
                                              for (
                                                  var n = r.length, i = !1;
                                                  n-- && (i = E(e[r[n]], t[r[n]], null, !0));

                                              );
                                              return i;
                                          }
                                        : function (t) {
                                              var e = t[o];
                                              return s === e && (0 !== s || 1 / s == 1 / e);
                                          };
                                }),
                                (f.defaults = function (t, e, n) {
                                    var i,
                                        r = t,
                                        o = r;
                                    if (!r) return o;
                                    for (
                                        var s = arguments,
                                            l = 0,
                                            u = "number" == typeof n ? 2 : s.length;
                                        ++l < u;

                                    )
                                        if ((r = s[l]) && it[typeof r])
                                            for (
                                                var a = -1,
                                                    c = it[typeof r] && St(r),
                                                    h = c ? c.length : 0;
                                                ++a < h;

                                            )
                                                void 0 === o[(i = c[a])] && (o[i] = r[i]);
                                    return o;
                                }),
                                (f.defer = function (t) {
                                    if (!L(t)) throw new TypeError();
                                    var e = h(arguments, 1);
                                    return setTimeout(function () {
                                        t.apply(U, e);
                                    }, 1);
                                }),
                                (f.difference = function (t) {
                                    return v(t, b(arguments, !0, !0, 1));
                                }),
                                (f.forEach = C),
                                (f.forIn = Ct),
                                (f.forOwn = qt),
                                (f.intersection = function () {
                                    for (
                                        var t = [],
                                            e = -1,
                                            n = arguments.length,
                                            o = l(),
                                            u = x(),
                                            h = u === i,
                                            f = l();
                                        ++e < n;

                                    ) {
                                        var p = arguments[e];
                                        (Lt(p) || A(p)) &&
                                            (t.push(p), o.push(h && p.length >= G && s(e ? t[e] : f)));
                                    }
                                    var d = t[0],
                                        g = -1,
                                        m = d ? d.length : 0,
                                        y = [];
                                    t: for (; ++g < m; ) {
                                        var v = o[0];
                                        if (((p = d[g]), (v ? r(v, p) : u(f, p)) < 0)) {
                                            for (e = n, (v || f).push(p); --e; )
                                                if (((v = o[e]), (v ? r(v, p) : u(t[e], p)) < 0))
                                                    continue t;
                                            y.push(p);
                                        }
                                    }
                                    for (; n--; ) (v = o[n]) && c(v);
                                    return (a(o), a(f), y);
                                }),
                                (f.invoke = function (t, e) {
                                    var n = h(arguments, 2),
                                        i = -1,
                                        r = "function" == typeof e,
                                        o = t ? t.length : 0,
                                        s = Array("number" == typeof o ? o : 0);
                                    return (
                                        C(t, function (t) {
                                            s[++i] = (r ? e : t[e]).apply(t, n);
                                        }),
                                        s
                                    );
                                }),
                                (f.keys = St),
                                (f.map = q),
                                (f.omit = function (t, e, n) {
                                    var i = {};
                                    if ("function" != typeof e) {
                                        var r = [];
                                        Ct(t, function (t, e) {
                                            r.push(e);
                                        });
                                        for (
                                            var o = -1, s = (r = v(r, b(arguments, !0, !1, 1))).length;
                                            ++o < s;

                                        ) {
                                            var l = r[o];
                                            i[l] = t[l];
                                        }
                                    } else
                                        ((e = f.createCallback(e, n, 3)),
                                            Ct(t, function (t, n, r) {
                                                e(t, n, r) || (i[n] = t);
                                            }));
                                    return i;
                                }),
                                (f.partial = function (t) {
                                    return _(t, 16, h(arguments, 1));
                                }),
                                (f.property = R),
                                (f.values = function (t) {
                                    for (var e = -1, n = St(t), i = n.length, r = Array(i); ++e < i; )
                                        r[e] = t[n[e]];
                                    return r;
                                }),
                                (f.collect = q),
                                (f.each = C),
                                (f.extend = Nt),
                                (f.clone = function (t, e, n, i) {
                                    return (
                                        "boolean" != typeof e &&
                                            null != e &&
                                            ((i = n), (n = e), (e = !1)),
                                        d(t, e, "function" == typeof n && m(n, i, 1))
                                    );
                                }),
                                (f.every = N),
                                (f.identity = D),
                                (f.indexOf = k),
                                (f.isArguments = A),
                                (f.isArray = Lt),
                                (f.isElement = function (t) {
                                    return (t && 1 === t.nodeType) || !1;
                                }),
                                (f.isEqual = function (t, e, n, i) {
                                    return E(t, e, "function" == typeof n && m(n, i, 2));
                                }),
                                (f.isFunction = L),
                                (f.isNumber = function (t) {
                                    return (
                                        "number" == typeof t ||
                                        (t && "object" == typeof t && ht.call(t) == Q) ||
                                        !1
                                    );
                                }),
                                (f.isObject = S),
                                (f.isString = function (t) {
                                    return (
                                        "string" == typeof t ||
                                        (t && "object" == typeof t && ht.call(t) == tt) ||
                                        !1
                                    );
                                }),
                                (f.noop = M),
                                (f.reduce = w),
                                (f.sortedIndex = I),
                                (f.uniqueId = function (t) {
                                    var e = ++F;
                                    return String(null == t ? "" : t) + e;
                                }),
                                (f.all = N),
                                (f.foldl = w),
                                (f.inject = w),
                                (f.last = function (t, e, n) {
                                    var i = 0,
                                        r = t ? t.length : 0;
                                    if ("number" != typeof e && null != e) {
                                        var o = r;
                                        for (e = f.createCallback(e, n, 3); o-- && e(t[o], o, t); ) i++;
                                    } else if (null == (i = e) || n) return t ? t[r - 1] : U;
                                    return h(t, _t(0, r - i));
                                }),
                                (f.VERSION = "2.4.1"),
                                ot && st ? (lt ? ((st.exports = f)._ = f) : (ot._ = f)) : (rt._ = f));
                        }).call(this);
                    }).call(
                        this,
                        "undefined" != typeof global
                            ? global
                            : "undefined" != typeof self
                              ? self
                              : "undefined" != typeof window
                                ? window
                                : {}
                    );
                },
                {}
            ],
            2: [
                function (t, e, n) {
                    !(function (t) {
                        function e() {
                            ((this._events = {}), this._conf && i.call(this, this._conf));
                        }
                        function i(t) {
                            t &&
                                ((this._conf = t),
                                t.delimiter && (this.delimiter = t.delimiter),
                                t.maxListeners && (this._events.maxListeners = t.maxListeners),
                                t.wildcard && (this.wildcard = t.wildcard),
                                t.newListener && (this.newListener = t.newListener),
                                this.wildcard && (this.listenerTree = {}));
                        }
                        function r(t) {
                            ((this._events = {}), (this.newListener = !1), i.call(this, t));
                        }
                        function o(t, e, n, i) {
                            if (!n) return [];
                            var r,
                                s,
                                l,
                                u,
                                a,
                                c,
                                h,
                                f = [],
                                p = e.length,
                                d = e[i],
                                g = e[i + 1];
                            if (i === p && n._listeners) {
                                if ("function" == typeof n._listeners)
                                    return (t && t.push(n._listeners), [n]);
                                for (r = 0, s = n._listeners.length; r < s; r++)
                                    t && t.push(n._listeners[r]);
                                return [n];
                            }
                            if ("*" === d || "**" === d || n[d]) {
                                if ("*" === d) {
                                    for (l in n)
                                        "_listeners" !== l &&
                                            n.hasOwnProperty(l) &&
                                            (f = f.concat(o(t, e, n[l], i + 1)));
                                    return f;
                                }
                                if ("**" === d) {
                                    (h = i + 1 === p || (i + 2 === p && "*" === g)) &&
                                        n._listeners &&
                                        (f = f.concat(o(t, e, n, p)));
                                    for (l in n)
                                        "_listeners" !== l &&
                                            n.hasOwnProperty(l) &&
                                            ("*" === l || "**" === l
                                                ? (n[l]._listeners &&
                                                      !h &&
                                                      (f = f.concat(o(t, e, n[l], p))),
                                                  (f = f.concat(o(t, e, n[l], i))))
                                                : (f =
                                                      l === g
                                                          ? f.concat(o(t, e, n[l], i + 2))
                                                          : f.concat(o(t, e, n[l], i))));
                                    return f;
                                }
                                f = f.concat(o(t, e, n[d], i + 1));
                            }
                            if (((u = n["*"]) && o(t, e, u, i + 1), (a = n["**"])))
                                if (i < p) {
                                    a._listeners && o(t, e, a, p);
                                    for (l in a)
                                        "_listeners" !== l &&
                                            a.hasOwnProperty(l) &&
                                            (l === g
                                                ? o(t, e, a[l], i + 2)
                                                : l === d
                                                  ? o(t, e, a[l], i + 1)
                                                  : (((c = {})[l] = a[l]),
                                                    o(t, e, { "**": c }, i + 1)));
                                } else
                                    a._listeners
                                        ? o(t, e, a, p)
                                        : a["*"] && a["*"]._listeners && o(t, e, a["*"], p);
                            return f;
                        }
                        function s(t, e) {
                            for (
                                var n = 0,
                                    i = (t = "string" == typeof t ? t.split(this.delimiter) : t.slice())
                                        .length;
                                n + 1 < i;
                                n++
                            )
                                if ("**" === t[n] && "**" === t[n + 1]) return;
                            for (var r = this.listenerTree, o = t.shift(); o; ) {
                                if ((r[o] || (r[o] = {}), (r = r[o]), 0 === t.length)) {
                                    if (r._listeners) {
                                        if ("function" == typeof r._listeners)
                                            r._listeners = [r._listeners, e];
                                        else if (
                                            l(r._listeners) &&
                                            (r._listeners.push(e), !r._listeners.warned)
                                        ) {
                                            var s = u;
                                            (void 0 !== this._events.maxListeners &&
                                                (s = this._events.maxListeners),
                                                s > 0 &&
                                                    r._listeners.length > s &&
                                                    ((r._listeners.warned = !0),
                                                    console.error(
                                                        "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
                                                        r._listeners.length
                                                    ),
                                                    console.trace()));
                                        }
                                    } else r._listeners = e;
                                    return !0;
                                }
                                o = t.shift();
                            }
                            return !0;
                        }
                        var l = Array.isArray
                                ? Array.isArray
                                : function (t) {
                                      return "[object Array]" === Object.prototype.toString.call(t);
                                  },
                            u = 10;
                        ((r.prototype.delimiter = "."),
                            (r.prototype.setMaxListeners = function (t) {
                                (this._events || e.call(this),
                                    (this._events.maxListeners = t),
                                    this._conf || (this._conf = {}),
                                    (this._conf.maxListeners = t));
                            }),
                            (r.prototype.event = ""),
                            (r.prototype.once = function (t, e) {
                                return (this.many(t, 1, e), this);
                            }),
                            (r.prototype.many = function (t, e, n) {
                                function i() {
                                    (0 == --e && r.off(t, i), n.apply(this, arguments));
                                }
                                var r = this;
                                if ("function" != typeof n)
                                    throw new Error("many only accepts instances of Function");
                                return ((i._origin = n), this.on(t, i), r);
                            }),
                            (r.prototype.emit = function () {
                                this._events || e.call(this);
                                var t = arguments[0];
                                if (
                                    "newListener" === t &&
                                    !this.newListener &&
                                    !this._events.newListener
                                )
                                    return !1;
                                if (this._all) {
                                    for (
                                        var n = arguments.length, i = new Array(n - 1), r = 1;
                                        r < n;
                                        r++
                                    )
                                        i[r - 1] = arguments[r];
                                    for (r = 0, n = this._all.length; r < n; r++)
                                        ((this.event = t), this._all[r].apply(this, i));
                                }
                                if (
                                    "error" === t &&
                                    !(
                                        this._all ||
                                        this._events.error ||
                                        (this.wildcard && this.listenerTree.error)
                                    )
                                )
                                    throw arguments[1] instanceof Error
                                        ? arguments[1]
                                        : new Error("Uncaught, unspecified 'error' event.");
                                var s;
                                if (this.wildcard) {
                                    s = [];
                                    var l = "string" == typeof t ? t.split(this.delimiter) : t.slice();
                                    o.call(this, s, l, this.listenerTree, 0);
                                } else s = this._events[t];
                                if ("function" == typeof s) {
                                    if (((this.event = t), 1 === arguments.length)) s.call(this);
                                    else if (arguments.length > 1)
                                        switch (arguments.length) {
                                            case 2:
                                                s.call(this, arguments[1]);
                                                break;
                                            case 3:
                                                s.call(this, arguments[1], arguments[2]);
                                                break;
                                            default:
                                                for (
                                                    var n = arguments.length,
                                                        i = new Array(n - 1),
                                                        r = 1;
                                                    r < n;
                                                    r++
                                                )
                                                    i[r - 1] = arguments[r];
                                                s.apply(this, i);
                                        }
                                    return !0;
                                }
                                if (s) {
                                    for (
                                        var n = arguments.length, i = new Array(n - 1), r = 1;
                                        r < n;
                                        r++
                                    )
                                        i[r - 1] = arguments[r];
                                    for (var u = s.slice(), r = 0, n = u.length; r < n; r++)
                                        ((this.event = t), u[r].apply(this, i));
                                    return u.length > 0 || !!this._all;
                                }
                                return !!this._all;
                            }),
                            (r.prototype.on = function (t, n) {
                                if ("function" == typeof t) return (this.onAny(t), this);
                                if ("function" != typeof n)
                                    throw new Error("on only accepts instances of Function");
                                if (
                                    (this._events || e.call(this),
                                    this.emit("newListener", t, n),
                                    this.wildcard)
                                )
                                    return (s.call(this, t, n), this);
                                if (this._events[t]) {
                                    if ("function" == typeof this._events[t])
                                        this._events[t] = [this._events[t], n];
                                    else if (
                                        l(this._events[t]) &&
                                        (this._events[t].push(n), !this._events[t].warned)
                                    ) {
                                        var i = u;
                                        (void 0 !== this._events.maxListeners &&
                                            (i = this._events.maxListeners),
                                            i > 0 &&
                                                this._events[t].length > i &&
                                                ((this._events[t].warned = !0),
                                                console.error(
                                                    "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
                                                    this._events[t].length
                                                ),
                                                console.trace()));
                                    }
                                } else this._events[t] = n;
                                return this;
                            }),
                            (r.prototype.onAny = function (t) {
                                if ("function" != typeof t)
                                    throw new Error("onAny only accepts instances of Function");
                                return (this._all || (this._all = []), this._all.push(t), this);
                            }),
                            (r.prototype.addListener = r.prototype.on),
                            (r.prototype.off = function (t, e) {
                                if ("function" != typeof e)
                                    throw new Error("removeListener only takes instances of Function");
                                var n,
                                    i = [];
                                if (this.wildcard) {
                                    var r = "string" == typeof t ? t.split(this.delimiter) : t.slice();
                                    i = o.call(this, null, r, this.listenerTree, 0);
                                } else {
                                    if (!this._events[t]) return this;
                                    ((n = this._events[t]), i.push({ _listeners: n }));
                                }
                                for (var s = 0; s < i.length; s++) {
                                    var u = i[s];
                                    if (((n = u._listeners), l(n))) {
                                        for (var a = -1, c = 0, h = n.length; c < h; c++)
                                            if (
                                                n[c] === e ||
                                                (n[c].listener && n[c].listener === e) ||
                                                (n[c]._origin && n[c]._origin === e)
                                            ) {
                                                a = c;
                                                break;
                                            }
                                        if (a < 0) continue;
                                        return (
                                            this.wildcard
                                                ? u._listeners.splice(a, 1)
                                                : this._events[t].splice(a, 1),
                                            0 === n.length &&
                                                (this.wildcard
                                                    ? delete u._listeners
                                                    : delete this._events[t]),
                                            this
                                        );
                                    }
                                    (n === e ||
                                        (n.listener && n.listener === e) ||
                                        (n._origin && n._origin === e)) &&
                                        (this.wildcard ? delete u._listeners : delete this._events[t]);
                                }
                                return this;
                            }),
                            (r.prototype.offAny = function (t) {
                                var e,
                                    n = 0,
                                    i = 0;
                                if (t && this._all && this._all.length > 0) {
                                    for (n = 0, i = (e = this._all).length; n < i; n++)
                                        if (t === e[n]) return (e.splice(n, 1), this);
                                } else this._all = [];
                                return this;
                            }),
                            (r.prototype.removeListener = r.prototype.off),
                            (r.prototype.removeAllListeners = function (t) {
                                if (0 === arguments.length)
                                    return (!this._events || e.call(this), this);
                                if (this.wildcard)
                                    for (
                                        var n =
                                                "string" == typeof t
                                                    ? t.split(this.delimiter)
                                                    : t.slice(),
                                            i = o.call(this, null, n, this.listenerTree, 0),
                                            r = 0;
                                        r < i.length;
                                        r++
                                    )
                                        i[r]._listeners = null;
                                else {
                                    if (!this._events[t]) return this;
                                    this._events[t] = null;
                                }
                                return this;
                            }),
                            (r.prototype.listeners = function (t) {
                                if (this.wildcard) {
                                    var n = [],
                                        i = "string" == typeof t ? t.split(this.delimiter) : t.slice();
                                    return (o.call(this, n, i, this.listenerTree, 0), n);
                                }
                                return (
                                    this._events || e.call(this),
                                    this._events[t] || (this._events[t] = []),
                                    l(this._events[t]) || (this._events[t] = [this._events[t]]),
                                    this._events[t]
                                );
                            }),
                            (r.prototype.listenersAny = function () {
                                return this._all ? this._all : [];
                            }),
                            "object" == typeof n ? (n.EventEmitter2 = r) : (window.EventEmitter2 = r));
                    })();
                },
                {}
            ],
            3: [
                function (t, e, n) {
                    var i = t("fast-diff"),
                        r = t("./is"),
                        o = t("./op"),
                        s = String.fromCharCode(0),
                        l = function (t) {
                            r.array(t)
                                ? (this.ops = t)
                                : r.object(t) && r.array(t.ops)
                                  ? (this.ops = t.ops)
                                  : (this.ops = []);
                        };
                    ((l.prototype.insert = function (t, e) {
                        var n = {};
                        if (r.string(t)) {
                            if (0 === t.length) return this;
                            n.insert = t;
                        } else r.number(t) && (n.insert = t);
                        return (
                            r.object(e) && Object.keys(e).length > 0 && (n.attributes = e),
                            this.push(n)
                        );
                    }),
                        (l.prototype.delete = function (t) {
                            return t <= 0 ? this : this.push({ delete: t });
                        }),
                        (l.prototype.retain = function (t, e) {
                            if (t <= 0) return this;
                            var n = { retain: t };
                            return (
                                r.object(e) && Object.keys(e).length > 0 && (n.attributes = e),
                                this.push(n)
                            );
                        }),
                        (l.prototype.push = function (t) {
                            var e = this.ops.length,
                                n = this.ops[e - 1];
                            if (((t = o.clone(t)), r.object(n))) {
                                if (r.number(t.delete) && r.number(n.delete))
                                    return ((this.ops[e - 1] = { delete: n.delete + t.delete }), this);
                                if (
                                    r.number(n.delete) &&
                                    (r.string(t.insert) || r.number(t.insert)) &&
                                    ((e -= 1), (n = this.ops[e - 1]), !r.object(n))
                                )
                                    return (this.ops.unshift(t), this);
                                if (r.equal(t.attributes, n.attributes)) {
                                    if (r.string(t.insert) && r.string(n.insert))
                                        return (
                                            (this.ops[e - 1] = { insert: n.insert + t.insert }),
                                            r.object(t.attributes) &&
                                                (this.ops[e - 1].attributes = t.attributes),
                                            this
                                        );
                                    if (r.number(t.retain) && r.number(n.retain))
                                        return (
                                            (this.ops[e - 1] = { retain: n.retain + t.retain }),
                                            r.object(t.attributes) &&
                                                (this.ops[e - 1].attributes = t.attributes),
                                            this
                                        );
                                }
                            }
                            return (this.ops.splice(e, 0, t), this);
                        }),
                        (l.prototype.chop = function () {
                            var t = this.ops[this.ops.length - 1];
                            return (t && t.retain && !t.attributes && this.ops.pop(), this);
                        }),
                        (l.prototype.length = function () {
                            return this.ops.reduce(function (t, e) {
                                return t + o.length(e);
                            }, 0);
                        }),
                        (l.prototype.slice = function (t, e) {
                            ((t = t || 0), r.number(e) || (e = 1 / 0));
                            for (
                                var n = new l(), i = o.iterator(this.ops), s = 0;
                                s < e && i.hasNext();

                            ) {
                                var u;
                                (s < t ? (u = i.next(t - s)) : ((u = i.next(e - s)), n.push(u)),
                                    (s += o.length(u)));
                            }
                            return n;
                        }),
                        (l.prototype.compose = function (t) {
                            var e = o.iterator(this.ops),
                                n = o.iterator(t.ops);
                            for (this.ops = []; e.hasNext() || n.hasNext(); )
                                if ("insert" === n.peekType()) this.push(n.next());
                                else if ("delete" === e.peekType()) this.push(e.next());
                                else {
                                    var i = Math.min(e.peekLength(), n.peekLength()),
                                        s = e.next(i),
                                        l = n.next(i);
                                    if (r.number(l.retain)) {
                                        var u = {};
                                        r.number(s.retain) ? (u.retain = i) : (u.insert = s.insert);
                                        var a = o.attributes.compose(
                                            s.attributes,
                                            l.attributes,
                                            r.number(s.retain)
                                        );
                                        (a && (u.attributes = a), this.push(u));
                                    } else r.number(l.delete) && r.number(s.retain) && this.push(l);
                                }
                            return this.chop();
                        }),
                        (l.prototype.diff = function (t) {
                            var e = [this.ops, t.ops].map(function (e) {
                                    return e
                                        .map(function (n) {
                                            if (r.string(n.insert)) return n.insert;
                                            if (r.number(n.insert)) return s;
                                            var i = e === t.ops ? "on" : "with";
                                            throw new Error("diff() called " + i + " non-document");
                                        })
                                        .join("");
                                }),
                                n = i(e[0], e[1]),
                                u = o.iterator(this.ops),
                                a = o.iterator(t.ops),
                                c = new l();
                            return (
                                n.forEach(function (t) {
                                    for (var e = t[1].length; e > 0; ) {
                                        var n = 0;
                                        switch (t[0]) {
                                            case i.INSERT:
                                                ((n = Math.min(a.peekLength(), e)), c.push(a.next(n)));
                                                break;
                                            case i.DELETE:
                                                ((n = Math.min(e, u.peekLength())),
                                                    u.next(n),
                                                    c.delete(n));
                                                break;
                                            case i.EQUAL:
                                                n = Math.min(u.peekLength(), a.peekLength(), e);
                                                var r = u.next(n),
                                                    s = a.next(n);
                                                r.insert === s.insert
                                                    ? c.retain(
                                                          n,
                                                          o.attributes.diff(r.attributes, s.attributes)
                                                      )
                                                    : c.push(s).delete(n);
                                        }
                                        e -= n;
                                    }
                                }),
                                c.chop()
                            );
                        }),
                        (l.prototype.transform = function (t, e) {
                            if (((e = !!e), r.number(t))) return this.transformPosition(t, e);
                            for (
                                var n = o.iterator(this.ops), i = o.iterator(t.ops), s = new l();
                                n.hasNext() || i.hasNext();

                            )
                                if ("insert" !== n.peekType() || (!e && "insert" === i.peekType()))
                                    if ("insert" === i.peekType()) s.push(i.next());
                                    else {
                                        var u = Math.min(n.peekLength(), i.peekLength()),
                                            a = n.next(u),
                                            c = i.next(u);
                                        if (a.delete) continue;
                                        c.delete
                                            ? s.push(c)
                                            : s.retain(
                                                  u,
                                                  o.attributes.transform(a.attributes, c.attributes, e)
                                              );
                                    }
                                else s.retain(o.length(n.next()));
                            return s.chop();
                        }),
                        (l.prototype.transformPosition = function (t, e) {
                            e = !!e;
                            for (var n = o.iterator(this.ops), i = 0; n.hasNext() && i <= t; ) {
                                var r = n.peekLength(),
                                    s = n.peekType();
                                (n.next(),
                                    "delete" !== s
                                        ? ("insert" === s && (i < t || !e) && (t += r), (i += r))
                                        : (t -= Math.min(r, t - i)));
                            }
                            return t;
                        }),
                        (e.exports = l));
                },
                { "./is": 4, "./op": 5, "fast-diff": 6 }
            ],
            4: [
                function (t, e, n) {
                    e.exports = {
                        equal: function (t, e) {
                            if (t === e) return !0;
                            if (null == t && null == e) return !0;
                            if (null == t || null == e) return !1;
                            if (Object.keys(t).length != Object.keys(e).length) return !1;
                            for (var n in t) if (t[n] !== e[n]) return !1;
                            return !0;
                        },
                        array: function (t) {
                            return Array.isArray(t);
                        },
                        number: function (t) {
                            return (
                                "number" == typeof t ||
                                ("object" == typeof t &&
                                    "[object Number]" === Object.prototype.toString.call(t))
                            );
                        },
                        object: function (t) {
                            return !!t && ("function" == typeof t || "object" == typeof t);
                        },
                        string: function (t) {
                            return (
                                "string" == typeof t ||
                                ("object" == typeof t &&
                                    "[object String]" === Object.prototype.toString.call(t))
                            );
                        }
                    };
                },
                {}
            ],
            5: [
                function (t, e, n) {
                    function i(t) {
                        ((this.ops = t), (this.index = 0), (this.offset = 0));
                    }
                    var r = t("./is"),
                        o = {
                            attributes: {
                                clone: function (t, e) {
                                    return r.object(t)
                                        ? Object.keys(t).reduce(function (n, i) {
                                              return (
                                                  void 0 === t[i] ||
                                                      (null === t[i] && !e) ||
                                                      (n[i] = t[i]),
                                                  n
                                              );
                                          }, {})
                                        : {};
                                },
                                compose: function (t, e, n) {
                                    (r.object(t) || (t = {}), r.object(e) || (e = {}));
                                    var i = this.clone(e, n);
                                    for (var o in t)
                                        void 0 !== t[o] && void 0 === e[o] && (i[o] = t[o]);
                                    return Object.keys(i).length > 0 ? i : void 0;
                                },
                                diff: function (t, e) {
                                    (r.object(t) || (t = {}), r.object(e) || (e = {}));
                                    var n = Object.keys(t)
                                        .concat(Object.keys(e))
                                        .reduce(function (n, i) {
                                            return (
                                                t[i] !== e[i] && (n[i] = void 0 === e[i] ? null : e[i]),
                                                n
                                            );
                                        }, {});
                                    return Object.keys(n).length > 0 ? n : void 0;
                                },
                                transform: function (t, e, n) {
                                    if (!r.object(t)) return e;
                                    if (r.object(e)) {
                                        if (!n) return e;
                                        var i = Object.keys(e).reduce(function (n, i) {
                                            return (void 0 === t[i] && (n[i] = e[i]), n);
                                        }, {});
                                        return Object.keys(i).length > 0 ? i : void 0;
                                    }
                                }
                            },
                            clone: function (t) {
                                var e = this.attributes.clone(t);
                                return (
                                    r.object(e.attributes) &&
                                        (e.attributes = this.attributes.clone(e.attributes, !0)),
                                    e
                                );
                            },
                            iterator: function (t) {
                                return new i(t);
                            },
                            length: function (t) {
                                return r.number(t.delete)
                                    ? t.delete
                                    : r.number(t.retain)
                                      ? t.retain
                                      : r.string(t.insert)
                                        ? t.insert.length
                                        : 1;
                            }
                        };
                    ((i.prototype.hasNext = function () {
                        return this.peekLength() < 1 / 0;
                    }),
                        (i.prototype.next = function (t) {
                            t || (t = 1 / 0);
                            var e = this.ops[this.index];
                            if (e) {
                                var n = this.offset,
                                    i = o.length(e);
                                if (
                                    (t >= i - n
                                        ? ((t = i - n), (this.index += 1), (this.offset = 0))
                                        : (this.offset += t),
                                    r.number(e.delete))
                                )
                                    return { delete: t };
                                var s = {};
                                return (
                                    e.attributes && (s.attributes = e.attributes),
                                    r.number(e.retain)
                                        ? (s.retain = t)
                                        : r.string(e.insert)
                                          ? (s.insert = e.insert.substr(n, t))
                                          : (s.insert = e.insert),
                                    s
                                );
                            }
                            return { retain: 1 / 0 };
                        }),
                        (i.prototype.peekLength = function () {
                            return this.ops[this.index]
                                ? o.length(this.ops[this.index]) - this.offset
                                : 1 / 0;
                        }),
                        (i.prototype.peekType = function () {
                            return this.ops[this.index]
                                ? r.number(this.ops[this.index].delete)
                                    ? "delete"
                                    : r.number(this.ops[this.index].retain)
                                      ? "retain"
                                      : "insert"
                                : "retain";
                        }),
                        (e.exports = o));
                },
                { "./is": 4 }
            ],
            6: [
                function (t, e, n) {
                    function i(t, e) {
                        if (t == e) return t ? [[p, t]] : [];
                        var n = l(t, e),
                            i = t.substring(0, n);
                        n = u((t = t.substring(n)), (e = e.substring(n)));
                        var o = t.substring(t.length - n),
                            s = r(
                                (t = t.substring(0, t.length - n)),
                                (e = e.substring(0, e.length - n))
                            );
                        return (i && s.unshift([p, i]), o && s.push([p, o]), c(s), s);
                    }
                    function r(t, e) {
                        var n;
                        if (!t) return [[f, e]];
                        if (!e) return [[h, t]];
                        var r = t.length > e.length ? t : e,
                            s = t.length > e.length ? e : t,
                            l = r.indexOf(s);
                        if (-1 != l)
                            return (
                                (n = [
                                    [f, r.substring(0, l)],
                                    [p, s],
                                    [f, r.substring(l + s.length)]
                                ]),
                                t.length > e.length && (n[0][0] = n[2][0] = h),
                                n
                            );
                        if (1 == s.length)
                            return [
                                [h, t],
                                [f, e]
                            ];
                        var u = a(t, e);
                        if (u) {
                            var c = u[0],
                                d = u[1],
                                g = u[2],
                                m = u[3],
                                y = u[4],
                                v = i(c, g),
                                b = i(d, m);
                            return v.concat([[p, y]], b);
                        }
                        return o(t, e);
                    }
                    function o(t, e) {
                        for (
                            var n = t.length,
                                i = e.length,
                                r = Math.ceil((n + i) / 2),
                                o = r,
                                l = 2 * r,
                                u = new Array(l),
                                a = new Array(l),
                                c = 0;
                            c < l;
                            c++
                        )
                            ((u[c] = -1), (a[c] = -1));
                        ((u[o + 1] = 0), (a[o + 1] = 0));
                        for (
                            var p = n - i, d = p % 2 != 0, g = 0, m = 0, y = 0, v = 0, b = 0;
                            b < r;
                            b++
                        ) {
                            for (var E = -b + g; E <= b - m; E += 2) {
                                for (
                                    var _,
                                        x = o + E,
                                        T =
                                            (_ =
                                                E == -b || (E != b && u[x - 1] < u[x + 1])
                                                    ? u[x + 1]
                                                    : u[x - 1] + 1) - E;
                                    _ < n && T < i && t.charAt(_) == e.charAt(T);

                                )
                                    (_++, T++);
                                if (((u[x] = _), _ > n)) m += 2;
                                else if (T > i) g += 2;
                                else if (
                                    d &&
                                    (S = o + p - E) >= 0 &&
                                    S < l &&
                                    -1 != a[S] &&
                                    _ >= (L = n - a[S])
                                )
                                    return s(t, e, _, T);
                            }
                            for (var A = -b + y; A <= b - v; A += 2) {
                                for (
                                    var L,
                                        S = o + A,
                                        N =
                                            (L =
                                                A == -b || (A != b && a[S - 1] < a[S + 1])
                                                    ? a[S + 1]
                                                    : a[S - 1] + 1) - A;
                                    L < n && N < i && t.charAt(n - L - 1) == e.charAt(i - N - 1);

                                )
                                    (L++, N++);
                                if (((a[S] = L), L > n)) v += 2;
                                else if (N > i) y += 2;
                                else if (!d && (x = o + p - A) >= 0 && x < l && -1 != u[x]) {
                                    T = o + (_ = u[x]) - x;
                                    if (((L = n - L), _ >= L)) return s(t, e, _, T);
                                }
                            }
                        }
                        return [
                            [h, t],
                            [f, e]
                        ];
                    }
                    function s(t, e, n, r) {
                        var o = t.substring(0, n),
                            s = e.substring(0, r),
                            l = t.substring(n),
                            u = e.substring(r),
                            a = i(o, s),
                            c = i(l, u);
                        return a.concat(c);
                    }
                    function l(t, e) {
                        if (!t || !e || t.charAt(0) != e.charAt(0)) return 0;
                        for (var n = 0, i = Math.min(t.length, e.length), r = i, o = 0; n < r; )
                            (t.substring(o, r) == e.substring(o, r) ? (o = n = r) : (i = r),
                                (r = Math.floor((i - n) / 2 + n)));
                        return r;
                    }
                    function u(t, e) {
                        if (!t || !e || t.charAt(t.length - 1) != e.charAt(e.length - 1)) return 0;
                        for (var n = 0, i = Math.min(t.length, e.length), r = i, o = 0; n < r; )
                            (t.substring(t.length - r, t.length - o) ==
                            e.substring(e.length - r, e.length - o)
                                ? (o = n = r)
                                : (i = r),
                                (r = Math.floor((i - n) / 2 + n)));
                        return r;
                    }
                    function a(t, e) {
                        function n(t, e, n) {
                            for (
                                var i,
                                    r,
                                    o,
                                    s,
                                    a = t.substring(n, n + Math.floor(t.length / 4)),
                                    c = -1,
                                    h = "";
                                -1 != (c = e.indexOf(a, c + 1));

                            ) {
                                var f = l(t.substring(n), e.substring(c)),
                                    p = u(t.substring(0, n), e.substring(0, c));
                                h.length < p + f &&
                                    ((h = e.substring(c - p, c) + e.substring(c, c + f)),
                                    (i = t.substring(0, n - p)),
                                    (r = t.substring(n + f)),
                                    (o = e.substring(0, c - p)),
                                    (s = e.substring(c + f)));
                            }
                            return 2 * h.length >= t.length ? [i, r, o, s, h] : null;
                        }
                        var i = t.length > e.length ? t : e,
                            r = t.length > e.length ? e : t;
                        if (i.length < 4 || 2 * r.length < i.length) return null;
                        var o,
                            s = n(i, r, Math.ceil(i.length / 4)),
                            a = n(i, r, Math.ceil(i.length / 2));
                        if (!s && !a) return null;
                        o = a ? (s && s[4].length > a[4].length ? s : a) : s;
                        var c, h, f, p;
                        return (
                            t.length > e.length
                                ? ((c = o[0]), (h = o[1]), (f = o[2]), (p = o[3]))
                                : ((f = o[0]), (p = o[1]), (c = o[2]), (h = o[3])),
                            [c, h, f, p, o[4]]
                        );
                    }
                    function c(t) {
                        t.push([p, ""]);
                        for (var e, n = 0, i = 0, r = 0, o = "", s = ""; n < t.length; )
                            switch (t[n][0]) {
                                case f:
                                    (r++, (s += t[n][1]), n++);
                                    break;
                                case h:
                                    (i++, (o += t[n][1]), n++);
                                    break;
                                case p:
                                    (i + r > 1
                                        ? (0 !== i &&
                                              0 !== r &&
                                              (0 !== (e = l(s, o)) &&
                                                  (n - i - r > 0 && t[n - i - r - 1][0] == p
                                                      ? (t[n - i - r - 1][1] += s.substring(0, e))
                                                      : (t.splice(0, 0, [p, s.substring(0, e)]), n++),
                                                  (s = s.substring(e)),
                                                  (o = o.substring(e))),
                                              0 !== (e = u(s, o)) &&
                                                  ((t[n][1] = s.substring(s.length - e) + t[n][1]),
                                                  (s = s.substring(0, s.length - e)),
                                                  (o = o.substring(0, o.length - e)))),
                                          0 === i
                                              ? t.splice(n - r, i + r, [f, s])
                                              : 0 === r
                                                ? t.splice(n - i, i + r, [h, o])
                                                : t.splice(n - i - r, i + r, [h, o], [f, s]),
                                          (n = n - i - r + (i ? 1 : 0) + (r ? 1 : 0) + 1))
                                        : 0 !== n && t[n - 1][0] == p
                                          ? ((t[n - 1][1] += t[n][1]), t.splice(n, 1))
                                          : n++,
                                        (r = 0),
                                        (i = 0),
                                        (o = ""),
                                        (s = ""));
                            }
                        "" === t[t.length - 1][1] && t.pop();
                        var a = !1;
                        for (n = 1; n < t.length - 1; )
                            (t[n - 1][0] == p &&
                                t[n + 1][0] == p &&
                                (t[n][1].substring(t[n][1].length - t[n - 1][1].length) == t[n - 1][1]
                                    ? ((t[n][1] =
                                          t[n - 1][1] +
                                          t[n][1].substring(0, t[n][1].length - t[n - 1][1].length)),
                                      (t[n + 1][1] = t[n - 1][1] + t[n + 1][1]),
                                      t.splice(n - 1, 1),
                                      (a = !0))
                                    : t[n][1].substring(0, t[n + 1][1].length) == t[n + 1][1] &&
                                      ((t[n - 1][1] += t[n + 1][1]),
                                      (t[n][1] = t[n][1].substring(t[n + 1][1].length) + t[n + 1][1]),
                                      t.splice(n + 1, 1),
                                      (a = !0))),
                                n++);
                        a && c(t);
                    }
                    var h = -1,
                        f = 1,
                        p = 0,
                        d = i;
                    ((d.INSERT = f), (d.DELETE = h), (d.EQUAL = p), (e.exports = d));
                },
                {}
            ],
            7: [
                function (t, e, n) {
                    e.exports = { version: "0.19.8" };
                },
                {}
            ],
            8: [
                function (t, e, n) {
                    var i, r, o, s, l, u, a, c;
                    ((c = t("lodash")),
                        (i = t("rich-text/lib/delta")),
                        (a = t("../lib/dom")),
                        (o = t("./format")),
                        (s = t("./line")),
                        (l = t("../lib/linked-list")),
                        (u = t("../lib/normalizer")),
                        (r = (function () {
                            function t(t, e) {
                                ((this.root = t),
                                    null == e && (e = {}),
                                    (this.formats = {}),
                                    c.each(e.formats, c.bind(this.addFormat, this)),
                                    this.setHTML(this.root.innerHTML));
                            }
                            return (
                                (t.prototype.addFormat = function (t, e) {
                                    return (
                                        c.isObject(e) || (e = o.FORMATS[t]),
                                        null != this.formats[t] &&
                                            console.warn("Overwriting format", t, this.formats[t]),
                                        (this.formats[t] = new o(e))
                                    );
                                }),
                                (t.prototype.appendLine = function (t) {
                                    return this.insertLineBefore(t, null);
                                }),
                                (t.prototype.findLeafAt = function (t, e) {
                                    var n, i, r;
                                    return (
                                        (r = this.findLineAt(t)),
                                        (n = r[0]),
                                        (i = r[1]),
                                        null != n ? n.findLeafAt(i, e) : [null, i]
                                    );
                                }),
                                (t.prototype.findLine = function (t) {
                                    for (var e; null != t && null == a.BLOCK_TAGS[t.tagName]; )
                                        t = t.parentNode;
                                    return (
                                        (e = null != t ? this.lineMap[t.id] : null),
                                        (null != e ? e.node : void 0) === t ? e : null
                                    );
                                }),
                                (t.prototype.findLineAt = function (t) {
                                    var e, n;
                                    if (!(this.lines.length > 0)) return [null, t];
                                    if (((n = this.toDelta().length()), t === n))
                                        return [this.lines.last, this.lines.last.length];
                                    if (t > n) return [null, t - n];
                                    for (e = this.lines.first; null != e; ) {
                                        if (t < e.length) return [e, t];
                                        ((t -= e.length), (e = e.next));
                                    }
                                    return [null, t];
                                }),
                                (t.prototype.getHTML = function () {
                                    var t, e;
                                    return (
                                        (e = this.root.innerHTML),
                                        (e = e.replace(/\>\s+\</g, ">&nbsp;<")),
                                        (t = document.createElement("div")),
                                        (t.innerHTML = e),
                                        c.each(t.querySelectorAll("." + s.CLASS_NAME), function (t) {
                                            return (
                                                a(t).removeClass(s.CLASS_NAME),
                                                t.removeAttribute("id")
                                            );
                                        }),
                                        t.innerHTML
                                    );
                                }),
                                (t.prototype.insertLineBefore = function (t, e) {
                                    var n;
                                    return (
                                        (n = new s(this, t)),
                                        null != e
                                            ? (a(t.parentNode).isElement() ||
                                                  this.root.insertBefore(t, e.node),
                                              this.lines.insertAfter(e.prev, n))
                                            : (a(t.parentNode).isElement() || this.root.appendChild(t),
                                              this.lines.append(n)),
                                        (this.lineMap[n.id] = n),
                                        n
                                    );
                                }),
                                (t.prototype.mergeLines = function (t, e) {
                                    return (
                                        e.length > 1 &&
                                            (1 === t.length && a(t.leaves.last.node).remove(),
                                            c.each(a(e.node).childNodes(), function (e) {
                                                if (e.tagName !== a.DEFAULT_BREAK_TAG)
                                                    return t.node.appendChild(e);
                                            })),
                                        this.removeLine(e),
                                        t.rebuild()
                                    );
                                }),
                                (t.prototype.optimizeLines = function () {
                                    return c.each(this.lines.toArray(), function (t, e) {
                                        return (t.optimize(), !0);
                                    });
                                }),
                                (t.prototype.rebuild = function () {
                                    var t, e, n;
                                    for (
                                        e = this.lines.toArray(),
                                            null != (t = this.root.firstChild) &&
                                                null != a.LIST_TAGS[t.tagName] &&
                                                (t = t.firstChild),
                                            c.each(
                                                e,
                                                (function (e) {
                                                    return function (n, i) {
                                                        for (var r; n.node !== t; ) {
                                                            if (
                                                                n.node.parentNode !== e.root &&
                                                                (null != (r = n.node.parentNode)
                                                                    ? r.parentNode
                                                                    : void 0) !== e.root
                                                            )
                                                                return e.removeLine(n);
                                                            ((t = u.normalizeLine(t)),
                                                                e.insertLineBefore(t, n),
                                                                (t = a(t).nextLineNode(e.root)));
                                                        }
                                                        return (
                                                            n.outerHTML !== t.outerHTML &&
                                                                ((n.node = u.normalizeLine(n.node)),
                                                                n.rebuild()),
                                                            (t = a(t).nextLineNode(e.root))
                                                        );
                                                    };
                                                })(this)
                                            ),
                                            n = [];
                                        null != t;

                                    )
                                        ((t = u.normalizeLine(t)),
                                            this.appendLine(t),
                                            n.push((t = a(t).nextLineNode(this.root))));
                                    return n;
                                }),
                                (t.prototype.removeLine = function (t) {
                                    return (
                                        null != t.node.parentNode &&
                                            (a.LIST_TAGS[t.node.parentNode.tagName] &&
                                            1 === t.node.parentNode.childNodes.length
                                                ? a(t.node.parentNode).remove()
                                                : a(t.node).remove()),
                                        delete this.lineMap[t.id],
                                        this.lines.remove(t)
                                    );
                                }),
                                (t.prototype.setHTML = function (t) {
                                    return (
                                        (t = u.stripComments(t)),
                                        (t = u.stripWhitespace(t)),
                                        (this.root.innerHTML = t),
                                        (this.lines = new l()),
                                        (this.lineMap = {}),
                                        this.rebuild()
                                    );
                                }),
                                (t.prototype.splitLine = function (t, e) {
                                    var n, i, r, o;
                                    return (
                                        (e = Math.min(e, t.length - 1)),
                                        (o = a(t.node).split(e, !0)),
                                        (n = o[0]),
                                        (i = o[1]),
                                        (t.node = n),
                                        t.rebuild(),
                                        (r = this.insertLineBefore(i, t.next)),
                                        (r.formats = c.clone(t.formats)),
                                        r.resetContent(),
                                        r
                                    );
                                }),
                                (t.prototype.toDelta = function () {
                                    var t, e;
                                    return (
                                        (e = this.lines.toArray()),
                                        (t = new i()),
                                        c.each(e, function (e) {
                                            return c.each(e.delta.ops, function (e) {
                                                return t.push(e);
                                            });
                                        }),
                                        t
                                    );
                                }),
                                t
                            );
                        })()),
                        (e.exports = r));
                },
                {
                    "../lib/dom": 16,
                    "../lib/linked-list": 17,
                    "../lib/normalizer": 18,
                    "./format": 10,
                    "./line": 12,
                    lodash: 1,
                    "rich-text/lib/delta": 3
                }
            ],
            9: [
                function (t, e, n) {
                    var i, r, o, s, l;
                    ((l = t("lodash")),
                        (s = t("../lib/dom")),
                        (i = t("./document")),
                        t("./line"),
                        (o = t("./selection")),
                        (r = (function () {
                            function t(t, e, n) {
                                ((this.root = t),
                                    (this.quill = e),
                                    (this.options = null != n ? n : {}),
                                    this.root.setAttribute("id", this.options.id),
                                    (this.doc = new i(this.root, this.options)),
                                    (this.delta = this.doc.toDelta()),
                                    (this.selection = new o(this.doc, this.quill)),
                                    (this.timer = setInterval(
                                        l.bind(this.checkUpdate, this),
                                        this.options.pollInterval
                                    )),
                                    this.options.readOnly || this.enable());
                            }
                            return (
                                (t.sources = { API: "api", SILENT: "silent", USER: "user" }),
                                (t.prototype.destroy = function () {
                                    return clearInterval(this.timer);
                                }),
                                (t.prototype.disable = function () {
                                    return this.enable(!1);
                                }),
                                (t.prototype.enable = function (t) {
                                    return (
                                        null == t && (t = !0),
                                        this.root.setAttribute("contenteditable", t)
                                    );
                                }),
                                (t.prototype.applyDelta = function (e, n) {
                                    var i;
                                    if (
                                        ((i = this._update()) &&
                                            (i = (e = i.transform(e, !0)).transform(i, !1)),
                                        e.ops.length > 0 &&
                                            ((e = this._trackDelta(
                                                (function (t) {
                                                    return function () {
                                                        var n;
                                                        return (
                                                            (n = 0),
                                                            l.each(e.ops, function (e) {
                                                                return l.isString(e.insert)
                                                                    ? (t._insertAt(
                                                                          n,
                                                                          e.insert,
                                                                          e.attributes
                                                                      ),
                                                                      (n += e.insert.length))
                                                                    : l.isNumber(e.insert)
                                                                      ? (t._insertAt(
                                                                            n,
                                                                            s.EMBED_TEXT,
                                                                            e.attributes
                                                                        ),
                                                                        (n += 1))
                                                                      : l.isNumber(e.delete)
                                                                        ? t._deleteAt(n, e.delete)
                                                                        : l.isNumber(e.retain)
                                                                          ? (l.each(
                                                                                e.attributes,
                                                                                function (i, r) {
                                                                                    return t._formatAt(
                                                                                        n,
                                                                                        e.retain,
                                                                                        r,
                                                                                        i
                                                                                    );
                                                                                }
                                                                            ),
                                                                            (n += e.retain))
                                                                          : void 0;
                                                            }),
                                                            t.selection.shiftAfter(
                                                                0,
                                                                0,
                                                                l.bind(t.doc.optimizeLines, t.doc)
                                                            )
                                                        );
                                                    };
                                                })(this)
                                            )),
                                            (this.delta = this.doc.toDelta()),
                                            (this.innerHTML = this.root.innerHTML),
                                            e &&
                                                n !== t.sources.SILENT &&
                                                this.quill.emit(
                                                    this.quill.constructor.events.TEXT_CHANGE,
                                                    e,
                                                    n
                                                )),
                                        i && i.ops.length > 0 && n !== t.sources.SILENT)
                                    )
                                        return this.quill.emit(
                                            this.quill.constructor.events.TEXT_CHANGE,
                                            i,
                                            t.sources.USER
                                        );
                                }),
                                (t.prototype.checkUpdate = function (e) {
                                    var n;
                                    return (
                                        null == e && (e = "user"),
                                        null == this.root.parentNode
                                            ? clearInterval(this.timer)
                                            : ((n = this._update()) &&
                                                  (this.delta.compose(n),
                                                  this.quill.emit(
                                                      this.quill.constructor.events.TEXT_CHANGE,
                                                      n,
                                                      e
                                                  )),
                                              n && (e = t.sources.SILENT),
                                              this.selection.update(e))
                                    );
                                }),
                                (t.prototype.focus = function () {
                                    return null != this.selection.range
                                        ? this.selection.setRange(this.selection.range)
                                        : this.root.focus();
                                }),
                                (t.prototype.getBounds = function (t) {
                                    var e, n, i, r, o, s, l;
                                    if (
                                        (this.checkUpdate(),
                                        (l = this.doc.findLeafAt(t, !0)),
                                        (i = l[0]),
                                        (r = l[1]),
                                        null == i)
                                    )
                                        throw new Error("Invalid index");
                                    return (
                                        (n = this.root.parentNode.getBoundingClientRect()),
                                        (s = "left"),
                                        0 === i.length
                                            ? (e = i.node.parentNode.getBoundingClientRect())
                                            : ((o = document.createRange()),
                                              r < i.length
                                                  ? (o.setStart(i.node, r), o.setEnd(i.node, r + 1))
                                                  : (o.setStart(i.node, r - 1),
                                                    o.setEnd(i.node, r),
                                                    (s = "right")),
                                              (e = o.getBoundingClientRect())),
                                        { height: e.height, left: e[s] - n.left, top: e.top - n.top }
                                    );
                                }),
                                (t.prototype.getDelta = function () {
                                    return this.delta;
                                }),
                                (t.prototype._deleteAt = function (t, e) {
                                    if (!(e <= 0))
                                        return this.selection.shiftAfter(
                                            t,
                                            -1 * e,
                                            (function (n) {
                                                return function () {
                                                    var i, r, o, s, l, u, a;
                                                    for (
                                                        o = (a = n.doc.findLineAt(t))[0],
                                                            u = a[1],
                                                            i = o,
                                                            s = o.length - u <= e && u > 0;
                                                        null != i && e > 0;

                                                    )
                                                        ((l = i.next),
                                                            (r = Math.min(i.length - u, e)),
                                                            0 === u && e >= i.length
                                                                ? n.doc.removeLine(i)
                                                                : i.deleteText(u, r),
                                                            (e -= r),
                                                            (i = l),
                                                            (u = 0));
                                                    if (s && o.next) return n.doc.mergeLines(o, o.next);
                                                };
                                            })(this)
                                        );
                                }),
                                (t.prototype._formatAt = function (t, e, n, i) {
                                    return this.selection.shiftAfter(
                                        t,
                                        0,
                                        (function (r) {
                                            return function () {
                                                var o, s, l, u, a;
                                                for (
                                                    s = (u = r.doc.findLineAt(t))[0], l = u[1], a = [];
                                                    null != s && e > 0;

                                                )
                                                    ((o = Math.min(e, s.length - l - 1)),
                                                        s.formatText(l, o, n, i),
                                                        (e -= o) > 0 && s.format(n, i),
                                                        (e -= 1),
                                                        (l = 0),
                                                        a.push((s = s.next)));
                                                return a;
                                            };
                                        })(this)
                                    );
                                }),
                                (t.prototype._insertAt = function (t, e, n) {
                                    return (
                                        null == n && (n = {}),
                                        this.selection.shiftAfter(
                                            t,
                                            e.length,
                                            (function (i) {
                                                return function () {
                                                    var r, o, u, a;
                                                    return (
                                                        (e = e.replace(/\r\n?/g, "\n")),
                                                        (o = e.split("\n")),
                                                        (a = i.doc.findLineAt(t)),
                                                        (r = a[0]),
                                                        (u = a[1]),
                                                        l.each(o, function (t, e) {
                                                            var a;
                                                            return (
                                                                null == r || r.length <= u
                                                                    ? (e < o.length - 1 ||
                                                                          t.length > 0) &&
                                                                      ((r = i.doc.appendLine(
                                                                          document.createElement(
                                                                              s.DEFAULT_BLOCK_TAG
                                                                          )
                                                                      )),
                                                                      (u = 0),
                                                                      r.insertText(u, t, n),
                                                                      r.format(n),
                                                                      (a = null))
                                                                    : (r.insertText(u, t, n),
                                                                      e < o.length - 1 &&
                                                                          ((a = i.doc.splitLine(
                                                                              r,
                                                                              u + t.length
                                                                          )),
                                                                          l.each(
                                                                              l.defaults(
                                                                                  {},
                                                                                  n,
                                                                                  r.formats
                                                                              ),
                                                                              function (t, e) {
                                                                                  return r.format(
                                                                                      e,
                                                                                      n[e]
                                                                                  );
                                                                              }
                                                                          ),
                                                                          (u = 0))),
                                                                (r = a)
                                                            );
                                                        })
                                                    );
                                                };
                                            })(this)
                                        )
                                    );
                                }),
                                (t.prototype._trackDelta = function (t) {
                                    var e;
                                    return (t(), (e = this.doc.toDelta()), this.delta.diff(e));
                                }),
                                (t.prototype._update = function () {
                                    var t;
                                    return (
                                        this.innerHTML !== this.root.innerHTML &&
                                        ((t = this._trackDelta(
                                            (function (t) {
                                                return function () {
                                                    return (
                                                        t.selection.preserve(
                                                            l.bind(t.doc.rebuild, t.doc)
                                                        ),
                                                        t.selection.shiftAfter(
                                                            0,
                                                            0,
                                                            l.bind(t.doc.optimizeLines, t.doc)
                                                        )
                                                    );
                                                };
                                            })(this)
                                        )),
                                        (this.innerHTML = this.root.innerHTML),
                                        t.ops.length > 0 && t)
                                    );
                                }),
                                t
                            );
                        })()),
                        (e.exports = r));
                },
                { "../lib/dom": 16, "./document": 8, "./line": 12, "./selection": 13, lodash: 1 }
            ],
            10: [
                function (t, e, n) {
                    var i, r, o;
                    ((o = t("lodash")),
                        (r = t("../lib/dom")),
                        (i = (function () {
                            function t(t) {
                                this.config = t;
                            }
                            return (
                                (t.types = { LINE: "line" }),
                                (t.FORMATS = {
                                    bold: { tag: "B", prepare: "bold" },
                                    italic: { tag: "I", prepare: "italic" },
                                    underline: { tag: "U", prepare: "underline" },
                                    strike: { tag: "S", prepare: "strikeThrough" },
                                    color: {
                                        style: "color",
                                        default: "rgb(0, 0, 0)",
                                        prepare: "foreColor"
                                    },
                                    background: {
                                        style: "backgroundColor",
                                        default: "rgb(255, 255, 255)",
                                        prepare: "backColor"
                                    },
                                    font: {
                                        style: "fontFamily",
                                        default: "'Helvetica', 'Arial', sans-serif",
                                        prepare: "fontName"
                                    },
                                    size: {
                                        style: "fontSize",
                                        default: "13px",
                                        prepare: function (t) {
                                            return document.execCommand(
                                                "fontSize",
                                                !1,
                                                r.convertFontSize(t)
                                            );
                                        }
                                    },
                                    link: { tag: "A", attribute: "href" },
                                    image: { tag: "IMG", attribute: "src" },
                                    align: { type: t.types.LINE, style: "textAlign", default: "left" },
                                    bullet: {
                                        type: t.types.LINE,
                                        exclude: "list",
                                        parentTag: "UL",
                                        tag: "LI"
                                    },
                                    list: {
                                        type: t.types.LINE,
                                        exclude: "bullet",
                                        parentTag: "OL",
                                        tag: "LI"
                                    }
                                }),
                                (t.prototype.add = function (e, n) {
                                    var i, s, l, u, a;
                                    return n
                                        ? this.value(e) === n
                                            ? e
                                            : (o.isString(this.config.parentTag) &&
                                                  ((l = document.createElement(this.config.parentTag)),
                                                  r(e).wrap(l),
                                                  e.parentNode.tagName ===
                                                      (null != (u = e.parentNode.previousSibling)
                                                          ? u.tagName
                                                          : void 0) &&
                                                      r(e.parentNode.previousSibling).merge(
                                                          e.parentNode
                                                      ),
                                                  e.parentNode.tagName ===
                                                      (null != (a = e.parentNode.nextSibling)
                                                          ? a.tagName
                                                          : void 0) &&
                                                      r(e.parentNode).merge(e.parentNode.nextSibling)),
                                              o.isString(this.config.tag) &&
                                                  ((i = document.createElement(this.config.tag)),
                                                  null != r.VOID_TAGS[i.tagName]
                                                      ? (null != e.parentNode && r(e).replace(i),
                                                        (e = i))
                                                      : this.isType(t.types.LINE)
                                                        ? (e = r(e).switchTag(this.config.tag))
                                                        : (r(e).wrap(i), (e = i))),
                                              (o.isString(this.config.style) ||
                                                  o.isString(this.config.attribute) ||
                                                  o.isString(this.config.class)) &&
                                                  (o.isString(this.config.class) &&
                                                      (e = this.remove(e)),
                                                  r(e).isTextNode() &&
                                                      ((s = document.createElement(
                                                          r.DEFAULT_INLINE_TAG
                                                      )),
                                                      r(e).wrap(s),
                                                      (e = s)),
                                                  o.isString(this.config.style) &&
                                                      n !== this.config.default &&
                                                      (e.style[this.config.style] = n),
                                                  o.isString(this.config.attribute) &&
                                                      e.setAttribute(this.config.attribute, n),
                                                  o.isString(this.config.class) &&
                                                      r(e).addClass(this.config.class + n)),
                                              e)
                                        : this.remove(e);
                                }),
                                (t.prototype.isType = function (t) {
                                    return t === this.config.type;
                                }),
                                (t.prototype.match = function (t) {
                                    var e, n, i, s;
                                    if (!r(t).isElement()) return !1;
                                    if (
                                        o.isString(this.config.parentTag) &&
                                        (null != (i = t.parentNode) ? i.tagName : void 0) !==
                                            this.config.parentTag
                                    )
                                        return !1;
                                    if (o.isString(this.config.tag) && t.tagName !== this.config.tag)
                                        return !1;
                                    if (
                                        o.isString(this.config.style) &&
                                        (!t.style[this.config.style] ||
                                            t.style[this.config.style] === this.config.default)
                                    )
                                        return !1;
                                    if (
                                        o.isString(this.config.attribute) &&
                                        !t.hasAttribute(this.config.attribute)
                                    )
                                        return !1;
                                    if (o.isString(this.config.class)) {
                                        for (e = 0, n = (s = r(t).classes()).length; e < n; e++)
                                            if (0 === s[e].indexOf(this.config.class)) return !0;
                                        return !1;
                                    }
                                    return !0;
                                }),
                                (t.prototype.prepare = function (t) {
                                    return o.isString(this.config.prepare)
                                        ? document.execCommand(this.config.prepare, !1, t)
                                        : o.isFunction(this.config.prepare)
                                          ? this.config.prepare(t)
                                          : void 0;
                                }),
                                (t.prototype.remove = function (e) {
                                    var n, i, s, l;
                                    if (!this.match(e)) return e;
                                    if (
                                        (o.isString(this.config.style) &&
                                            ((e.style[this.config.style] = ""),
                                            e.getAttribute("style") || e.removeAttribute("style")),
                                        o.isString(this.config.attribute) &&
                                            e.removeAttribute(this.config.attribute),
                                        o.isString(this.config.class))
                                    )
                                        for (i = 0, s = (l = r(e).classes()).length; i < s; i++)
                                            0 === (n = l[i]).indexOf(this.config.class) &&
                                                r(e).removeClass(n);
                                    return (
                                        o.isString(this.config.tag) &&
                                            (this.isType(t.types.LINE)
                                                ? (o.isString(this.config.parentTag) &&
                                                      (null != e.previousSibling &&
                                                          r(e).splitAncestors(e.parentNode.parentNode),
                                                      null != e.nextSibling &&
                                                          r(e.nextSibling).splitAncestors(
                                                              e.parentNode.parentNode
                                                          )),
                                                  (e = r(e).switchTag(r.DEFAULT_BLOCK_TAG)))
                                                : ((e = r(e).switchTag(r.DEFAULT_INLINE_TAG)),
                                                  null != r.EMBED_TAGS[this.config.tag] &&
                                                      r(e).text(r.EMBED_TEXT))),
                                        o.isString(this.config.parentTag) && r(e.parentNode).unwrap(),
                                        e.tagName !== r.DEFAULT_INLINE_TAG ||
                                            e.hasAttributes() ||
                                            (e = r(e).unwrap()),
                                        e
                                    );
                                }),
                                (t.prototype.value = function (t) {
                                    var e, n, i, s;
                                    if (this.match(t)) {
                                        if (o.isString(this.config.attribute))
                                            return t.getAttribute(this.config.attribute) || void 0;
                                        if (o.isString(this.config.style))
                                            return t.style[this.config.style] || void 0;
                                        if (o.isString(this.config.class)) {
                                            for (n = 0, i = (s = r(t).classes()).length; n < i; n++)
                                                if (0 === (e = s[n]).indexOf(this.config.class))
                                                    return e.slice(this.config.class.length);
                                        } else if (o.isString(this.config.tag)) return !0;
                                    }
                                }),
                                t
                            );
                        })()),
                        (e.exports = i));
                },
                { "../lib/dom": 16, lodash: 1 }
            ],
            11: [
                function (t, e, n) {
                    var i,
                        r,
                        o,
                        s = {}.hasOwnProperty,
                        l = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) s.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        };
                    ((o = t("lodash")),
                        (r = t("../lib/dom")),
                        t("./format"),
                        (i = (function (t) {
                            function e(t, n) {
                                ((this.node = t),
                                    (this.formats = o.clone(n)),
                                    (this.id = o.uniqueId(e.ID_PREFIX)),
                                    (this.text = r(this.node).text()),
                                    (this.length = this.text.length));
                            }
                            return (
                                l(e, t),
                                (e.ID_PREFIX = "ql-leaf-"),
                                (e.isLeafNode = function (t) {
                                    return r(t).isTextNode() || null == t.firstChild;
                                }),
                                (e.prototype.deleteText = function (t, e) {
                                    var n;
                                    if (e > 0)
                                        return (
                                            (this.text =
                                                this.text.slice(0, t) + this.text.slice(t + e)),
                                            (this.length = this.text.length),
                                            null != r.EMBED_TAGS[this.node.tagName]
                                                ? ((n = document.createTextNode(this.text)),
                                                  (this.node = r(this.node).replace(n)))
                                                : r(this.node).text(this.text)
                                        );
                                }),
                                (e.prototype.insertText = function (t, e) {
                                    var n;
                                    return (
                                        (this.text = this.text.slice(0, t) + e + this.text.slice(t)),
                                        r(this.node).isTextNode()
                                            ? r(this.node).text(this.text)
                                            : ((n = document.createTextNode(e)),
                                              this.node.tagName === r.DEFAULT_BREAK_TAG
                                                  ? (this.node = r(this.node).replace(n))
                                                  : (this.node.appendChild(n), (this.node = n))),
                                        (this.length = this.text.length)
                                    );
                                }),
                                e
                            );
                        })(t("../lib/linked-list").Node)),
                        (e.exports = i));
                },
                { "../lib/dom": 16, "../lib/linked-list": 17, "./format": 10, lodash: 1 }
            ],
            12: [
                function (t, e, n) {
                    var i,
                        r,
                        o,
                        s,
                        l,
                        u,
                        a,
                        c,
                        h = {}.hasOwnProperty,
                        f = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) h.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        };
                    ((c = t("lodash")),
                        (i = t("rich-text/lib/delta")),
                        (a = t("../lib/dom")),
                        (r = t("./format")),
                        (o = t("./leaf")),
                        (s = t("./line")),
                        (l = t("../lib/linked-list")),
                        (u = t("../lib/normalizer")),
                        (s = (function (t) {
                            function e(t, n) {
                                ((this.doc = t),
                                    (this.node = n),
                                    (this.id = c.uniqueId(e.ID_PREFIX)),
                                    (this.formats = {}),
                                    a(this.node).addClass(e.CLASS_NAME),
                                    this.rebuild(),
                                    e.__super__.constructor.call(this, this.node));
                            }
                            return (
                                f(e, t),
                                (e.CLASS_NAME = "ql-line"),
                                (e.ID_PREFIX = "ql-line-"),
                                (e.prototype.buildLeaves = function (t, e) {
                                    return c.each(
                                        a(t).childNodes(),
                                        (function (t) {
                                            return function (n) {
                                                var i;
                                                return (
                                                    (n = u.normalizeNode(n)),
                                                    (i = c.clone(e)),
                                                    c.each(t.doc.formats, function (t, e) {
                                                        if (!t.isType(r.types.LINE) && t.match(n))
                                                            return (i[e] = t.value(n));
                                                    }),
                                                    o.isLeafNode(n)
                                                        ? t.leaves.append(new o(n, i))
                                                        : t.buildLeaves(n, i)
                                                );
                                            };
                                        })(this)
                                    );
                                }),
                                (e.prototype.deleteText = function (t, e) {
                                    var n, i, r;
                                    if (e > 0) {
                                        for (
                                            i = (r = this.findLeafAt(t))[0], t = r[1];
                                            null != i && e > 0;

                                        )
                                            ((n = Math.min(e, i.length - t)),
                                                i.deleteText(t, n),
                                                (e -= n),
                                                (i = i.next),
                                                (t = 0));
                                        return this.rebuild();
                                    }
                                }),
                                (e.prototype.findLeaf = function (t) {
                                    var e;
                                    for (e = this.leaves.first; null != e; ) {
                                        if (e.node === t) return e;
                                        e = e.next;
                                    }
                                    return null;
                                }),
                                (e.prototype.findLeafAt = function (t, e) {
                                    var n;
                                    if ((null == e && (e = !1), t >= this.length - 1))
                                        return [this.leaves.last, this.leaves.last.length];
                                    for (n = this.leaves.first; null != n; ) {
                                        if (t < n.length || (t === n.length && e)) return [n, t];
                                        ((t -= n.length), (n = n.next));
                                    }
                                    return [this.leaves.last, t - this.leaves.last.length];
                                }),
                                (e.prototype.format = function (t, e) {
                                    var n;
                                    return (
                                        c.isObject(t) ? (n = t) : ((n = {})[t] = e),
                                        c.each(
                                            n,
                                            (function (t) {
                                                return function (e, n) {
                                                    var i, o;
                                                    if (null != (o = t.doc.formats[n]))
                                                        return (
                                                            o.isType(r.types.LINE) &&
                                                                (o.config.exclude &&
                                                                    t.formats[o.config.exclude] &&
                                                                    null !=
                                                                        (i =
                                                                            t.doc.formats[
                                                                                o.config.exclude
                                                                            ]) &&
                                                                    ((t.node = i.remove(t.node)),
                                                                    delete t.formats[o.config.exclude]),
                                                                (t.node = o.add(t.node, e))),
                                                            e ? (t.formats[n] = e) : delete t.formats[n]
                                                        );
                                                };
                                            })(this)
                                        ),
                                        this.resetContent()
                                    );
                                }),
                                (e.prototype.formatText = function (t, e, n, i) {
                                    var o, s, l, u, c, h, f, p;
                                    if (
                                        ((h = this.findLeafAt(t)),
                                        (s = h[0]),
                                        (l = h[1]),
                                        null != (o = this.doc.formats[n]) &&
                                            o.config.type !== r.types.LINE)
                                    ) {
                                        for (; null != s && e > 0; ) {
                                            if (
                                                ((u = s.next),
                                                (i && s.formats[n] !== i) ||
                                                    (!i && null != s.formats[n]))
                                            ) {
                                                if (((c = s.node), null != s.formats[n]))
                                                    for (a(c).splitAncestors(this.node); !o.match(c); )
                                                        c = c.parentNode;
                                                (l > 0 && ((f = a(c).split(l))[0], (c = f[1])),
                                                    s.length > l + e &&
                                                        ((c = (p = a(c).split(e))[0]), p[1]),
                                                    o.add(c, i));
                                            }
                                            ((e -= s.length - l), (l = 0), (s = u));
                                        }
                                        return this.rebuild();
                                    }
                                }),
                                (e.prototype.insertText = function (t, e, n) {
                                    var i, r, o, s, l, u;
                                    if ((null == n && (n = {}), e.length > 0))
                                        return (
                                            (l = this.findLeafAt(t)),
                                            (i = l[0]),
                                            (r = l[1]),
                                            c.isEqual(i.formats, n)
                                                ? (i.insertText(r, e), this.resetContent())
                                                : ((s = c.reduce(
                                                      n,
                                                      (function (t) {
                                                          return function (e, n, i) {
                                                              var r;
                                                              return (
                                                                  null != (r = t.doc.formats[i]) &&
                                                                      (e = r.add(e, n)),
                                                                  e
                                                              );
                                                          };
                                                      })(this),
                                                      document.createTextNode(e)
                                                  )),
                                                  (u = a(i.node).split(r)),
                                                  u[0],
                                                  (o = u[1]) &&
                                                      (o = a(o).splitAncestors(this.node).get()),
                                                  this.node.insertBefore(s, o),
                                                  this.rebuild())
                                        );
                                }),
                                (e.prototype.optimize = function () {
                                    return (u.optimizeLine(this.node), this.rebuild());
                                }),
                                (e.prototype.rebuild = function (t) {
                                    return (
                                        null == t && (t = !1),
                                        !(
                                            !t &&
                                            null != this.outerHTML &&
                                            this.outerHTML === this.node.outerHTML &&
                                            c.all(
                                                this.leaves.toArray(),
                                                (function (t) {
                                                    return function (e) {
                                                        return a(e.node).isAncestor(t.node);
                                                    };
                                                })(this)
                                            )
                                        ) &&
                                            ((this.node = u.normalizeNode(this.node)),
                                            0 !== a(this.node).length() ||
                                                this.node.querySelector(a.DEFAULT_BREAK_TAG) ||
                                                this.node.appendChild(
                                                    document.createElement(a.DEFAULT_BREAK_TAG)
                                                ),
                                            (this.leaves = new l()),
                                            (this.formats = c.reduce(
                                                this.doc.formats,
                                                (function (t) {
                                                    return function (e, n, i) {
                                                        return (
                                                            n.isType(r.types.LINE) &&
                                                                (n.match(t.node)
                                                                    ? (e[i] = n.value(t.node))
                                                                    : delete e[i]),
                                                            e
                                                        );
                                                    };
                                                })(this),
                                                this.formats
                                            )),
                                            this.buildLeaves(this.node, {}),
                                            this.resetContent(),
                                            !0)
                                    );
                                }),
                                (e.prototype.resetContent = function () {
                                    return (
                                        this.node.id !== this.id && (this.node.id = this.id),
                                        (this.outerHTML = this.node.outerHTML),
                                        (this.length = 1),
                                        (this.delta = new i()),
                                        c.each(
                                            this.leaves.toArray(),
                                            (function (t) {
                                                return function (e) {
                                                    return (
                                                        (t.length += e.length),
                                                        null != a.EMBED_TAGS[e.node.tagName]
                                                            ? t.delta.insert(1, e.formats)
                                                            : t.delta.insert(e.text, e.formats)
                                                    );
                                                };
                                            })(this)
                                        ),
                                        this.delta.insert("\n", this.formats)
                                    );
                                }),
                                e
                            );
                        })(l.Node)),
                        (e.exports = s));
                },
                {
                    "../lib/dom": 16,
                    "../lib/linked-list": 17,
                    "../lib/normalizer": 18,
                    "./format": 10,
                    "./leaf": 11,
                    "./line": 12,
                    lodash: 1,
                    "rich-text/lib/delta": 3
                }
            ],
            13: [
                function (t, e, n) {
                    var i, r, o, s;
                    (t("lodash"),
                        (s = t("../lib/dom")),
                        t("./leaf"),
                        (i = t("../lib/normalizer")),
                        (r = t("../lib/range")),
                        (o = (function () {
                            function t(t, e) {
                                ((this.doc = t),
                                    (this.emitter = e),
                                    (this.focus = !1),
                                    (this.range = new r(0, 0)),
                                    (this.nullDelay = !1),
                                    this.update("silent"));
                            }
                            return (
                                (t.prototype.checkFocus = function () {
                                    return document.activeElement === this.doc.root;
                                }),
                                (t.prototype.getRange = function (t) {
                                    var e, n, i;
                                    return (
                                        null == t && (t = !1),
                                        this.checkFocus()
                                            ? null == (n = this._getNativeRange())
                                                ? null
                                                : ((i = this._positionToIndex(
                                                      n.startContainer,
                                                      n.startOffset
                                                  )),
                                                  (e =
                                                      n.startContainer === n.endContainer &&
                                                      n.startOffset === n.endOffset
                                                          ? i
                                                          : this._positionToIndex(
                                                                n.endContainer,
                                                                n.endOffset
                                                            )),
                                                  new r(Math.min(i, e), Math.max(i, e)))
                                            : t
                                              ? this.range
                                              : null
                                    );
                                }),
                                (t.prototype.preserve = function (t) {
                                    var e, n, i, r, o, s, l, u, a;
                                    return (
                                        (i = this._getNativeRange()),
                                        null != i && this.checkFocus()
                                            ? ((s = this._encodePosition(
                                                  i.startContainer,
                                                  i.startOffset
                                              )),
                                              (r = s[0]),
                                              (o = s[1]),
                                              (l = this._encodePosition(i.endContainer, i.endOffset)),
                                              (e = l[0]),
                                              (n = l[1]),
                                              t(),
                                              (u = this._decodePosition(r, o)),
                                              (r = u[0]),
                                              (o = u[1]),
                                              (a = this._decodePosition(e, n)),
                                              (e = a[0]),
                                              (n = a[1]),
                                              this._setNativeRange(r, o, e, n))
                                            : t()
                                    );
                                }),
                                (t.prototype.setRange = function (t, e) {
                                    var n, i, r, o, s, l, u;
                                    return (
                                        null != t
                                            ? ((r = (s = this._indexToPosition(t.start))[0]),
                                              (o = s[1]),
                                              t.isCollapsed()
                                                  ? ((n = (l = [r, o])[0]), (i = l[1]))
                                                  : ((n = (u = this._indexToPosition(t.end))[0]),
                                                    (i = u[1])),
                                              this._setNativeRange(r, o, n, i))
                                            : this._setNativeRange(null),
                                        this.update(e)
                                    );
                                }),
                                (t.prototype.shiftAfter = function (t, e, n) {
                                    var i;
                                    if (((i = this.getRange()), n(), null != i))
                                        return (i.shift(t, e), this.setRange(i, "silent"));
                                }),
                                (t.prototype.update = function (t) {
                                    var e, n, i, o;
                                    return (
                                        (n = this.checkFocus()),
                                        (i = this.getRange(!0)),
                                        (e =
                                            "silent" !== t &&
                                            (!r.compare(i, this.range) || n !== this.focus)),
                                        (o = n ? i : null),
                                        null !== o || "user" !== t || this.nullDelay
                                            ? ((this.nullDelay = !1),
                                              (this.range = i),
                                              (this.focus = n),
                                              e
                                                  ? this.emitter.emit(
                                                        this.emitter.constructor.events
                                                            .SELECTION_CHANGE,
                                                        o,
                                                        t
                                                    )
                                                  : void 0)
                                            : (this.nullDelay = !0)
                                    );
                                }),
                                (t.prototype._decodePosition = function (t, e) {
                                    return (
                                        s(t).isElement() &&
                                            ((e += s(t.parentNode).childNodes().indexOf(t)),
                                            (t = t.parentNode)),
                                        [t, e]
                                    );
                                }),
                                (t.prototype._encodePosition = function (t, e) {
                                    for (var n; ; ) {
                                        if (
                                            s(t).isTextNode() ||
                                            t.tagName === s.DEFAULT_BREAK_TAG ||
                                            null != s.EMBED_TAGS[t.tagName]
                                        )
                                            return [t, e];
                                        if (e < t.childNodes.length) ((t = t.childNodes[e]), (e = 0));
                                        else {
                                            if (0 === t.childNodes.length)
                                                return (
                                                    null == i.TAGS[t.tagName] &&
                                                        ((n = document.createTextNode("")),
                                                        t.appendChild(n),
                                                        (t = n)),
                                                    [t, 0]
                                                );
                                            if (((t = t.lastChild), !s(t).isElement()))
                                                return [t, s(t).length()];
                                            if (
                                                t.tagName === s.DEFAULT_BREAK_TAG ||
                                                null != s.EMBED_TAGS[t.tagName]
                                            )
                                                return [t, 1];
                                            e = t.childNodes.length;
                                        }
                                    }
                                }),
                                (t.prototype._getNativeRange = function () {
                                    var t, e;
                                    return (
                                        (e = document.getSelection()),
                                        (null != e ? e.rangeCount : void 0) > 0 &&
                                        ((t = e.getRangeAt(0)),
                                        s(t.startContainer).isAncestor(this.doc.root, !0) &&
                                            (t.startContainer === t.endContainer ||
                                                s(t.endContainer).isAncestor(this.doc.root, !0)))
                                            ? t
                                            : null
                                    );
                                }),
                                (t.prototype._indexToPosition = function (t) {
                                    var e, n, i;
                                    return 0 === this.doc.lines.length
                                        ? [this.doc.root, 0]
                                        : ((i = this.doc.findLeafAt(t, !0)),
                                          (e = i[0]),
                                          (n = i[1]),
                                          this._decodePosition(e.node, n));
                                }),
                                (t.prototype._positionToIndex = function (t, e) {
                                    var n, i, r, o, s, l;
                                    if (
                                        ((l = this._encodePosition(t, e)),
                                        (i = l[0]),
                                        (e = l[1]),
                                        null == (o = this.doc.findLine(i)))
                                    )
                                        return 0;
                                    for (n = o.findLeaf(i), s = 0; null != o.prev; )
                                        s += (o = o.prev).length;
                                    if (null == n) return s;
                                    for (r = 0; null != n.prev; ) r += (n = n.prev).length;
                                    return s + r + e;
                                }),
                                (t.prototype._setNativeRange = function (t, e, n, i) {
                                    var r, o;
                                    if ((o = document.getSelection()))
                                        return null == t
                                            ? (o.removeAllRanges(), this.doc.root.blur())
                                            : (this.checkFocus() || this.doc.root.focus(),
                                              null == (r = this._getNativeRange()) ||
                                              t !== r.startContainer ||
                                              e !== r.startOffset ||
                                              n !== r.endContainer ||
                                              i !== r.endOffset
                                                  ? (o.removeAllRanges(),
                                                    (r = document.createRange()).setStart(t, e),
                                                    r.setEnd(n, i),
                                                    o.addRange(r))
                                                  : void 0);
                                }),
                                t
                            );
                        })()),
                        (e.exports = o));
                },
                {
                    "../lib/dom": 16,
                    "../lib/normalizer": 18,
                    "../lib/range": 20,
                    "./leaf": 11,
                    lodash: 1
                }
            ],
            14: [
                function (t, e, n) {
                    (t("./modules/authorship"),
                        t("./modules/image-tooltip"),
                        t("./modules/keyboard"),
                        t("./modules/link-tooltip"),
                        t("./modules/multi-cursor"),
                        t("./modules/paste-manager"),
                        t("./modules/toolbar"),
                        t("./modules/tooltip"),
                        t("./modules/undo-manager"),
                        (e.exports = t("./quill")));
                },
                {
                    "./modules/authorship": 21,
                    "./modules/image-tooltip": 22,
                    "./modules/keyboard": 23,
                    "./modules/link-tooltip": 24,
                    "./modules/multi-cursor": 25,
                    "./modules/paste-manager": 26,
                    "./modules/toolbar": 27,
                    "./modules/tooltip": 28,
                    "./modules/undo-manager": 29,
                    "./quill": 30
                }
            ],
            15: [
                function (t, e, n) {
                    var i,
                        r,
                        o = {}.hasOwnProperty,
                        s = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) o.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        };
                    ((r = t("./dom")),
                        (i = (function (t) {
                            function e() {
                                (e.__super__.constructor.apply(this, arguments),
                                    r(this.container).addClass("ql-color-picker"));
                            }
                            return (
                                s(e, t),
                                (e.prototype.buildItem = function (t, n, i) {
                                    var r;
                                    return (
                                        (r = e.__super__.buildItem.call(this, t, n, i)),
                                        (r.style.backgroundColor = n.value),
                                        r
                                    );
                                }),
                                e
                            );
                        })(t("./picker"))),
                        (e.exports = i));
                },
                { "./dom": 16, "./picker": 19 }
            ],
            16: [
                function (t, e, n) {
                    var i,
                        r,
                        o,
                        s,
                        l,
                        u = function (t, e) {
                            return function () {
                                return t.apply(e, arguments);
                            };
                        },
                        a = {}.hasOwnProperty,
                        c = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) a.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        };
                    ((l = t("lodash")),
                        (s = null),
                        (r = (function () {
                            function t(t) {
                                ((this.node = t), (this.trigger = u(this.trigger, this)));
                            }
                            return (
                                (t.prototype.addClass = function (t) {
                                    if (!this.hasClass(t))
                                        return (
                                            null != this.node.classList
                                                ? this.node.classList.add(t)
                                                : null != this.node.className &&
                                                  (this.node.className = (
                                                      this.node.className +
                                                      " " +
                                                      t
                                                  ).trim()),
                                            this
                                        );
                                }),
                                (t.prototype.attributes = function (t) {
                                    var e, n, i, r, o;
                                    if (t)
                                        return (
                                            l.each(
                                                t,
                                                (function (t) {
                                                    return function (e, n) {
                                                        return t.node.setAttribute(n, e);
                                                    };
                                                })(this)
                                            ),
                                            this
                                        );
                                    if (null == this.node.attributes) return {};
                                    for (
                                        t = {}, n = i = 0, r = (o = this.node.attributes).length;
                                        i < r;
                                        n = ++i
                                    )
                                        (o[n], (t[(e = this.node.attributes[n]).name] = e.value));
                                    return t;
                                }),
                                (t.prototype.child = function (t) {
                                    var e, n;
                                    for (
                                        e = this.node.firstChild, n = o(e).length();
                                        null != e && !(t < n);

                                    )
                                        ((t -= n), (e = e.nextSibling), (n = o(e).length()));
                                    return (
                                        null == e && ((e = this.node.lastChild), (t = o(e).length())),
                                        [e, t]
                                    );
                                }),
                                (t.prototype.childNodes = function () {
                                    return l.map(this.node.childNodes);
                                }),
                                (t.prototype.classes = function () {
                                    return this.node.className.split(/\s+/);
                                }),
                                (t.prototype.descendants = function () {
                                    return l.map(this.node.getElementsByTagName("*"));
                                }),
                                (t.prototype.get = function () {
                                    return this.node;
                                }),
                                (t.prototype.hasClass = function (t) {
                                    return null != this.node.classList
                                        ? this.node.classList.contains(t)
                                        : null != this.node.className && this.classes().indexOf(t) > -1;
                                }),
                                (t.prototype.isAncestor = function (t, e) {
                                    var n;
                                    if ((null == e && (e = !1), t === this.node)) return e;
                                    for (n = this.node; n; ) {
                                        if (n === t) return !0;
                                        n = n.parentNode;
                                    }
                                    return !1;
                                }),
                                (t.prototype.isElement = function () {
                                    var t;
                                    return (
                                        (null != (t = this.node) ? t.nodeType : void 0) ===
                                        o.ELEMENT_NODE
                                    );
                                }),
                                (t.prototype.isTextNode = function () {
                                    var t;
                                    return (
                                        (null != (t = this.node) ? t.nodeType : void 0) === o.TEXT_NODE
                                    );
                                }),
                                (t.prototype.length = function () {
                                    var t;
                                    return null == this.node
                                        ? 0
                                        : ((t = this.text().length),
                                          this.isElement() &&
                                              (t += this.node.querySelectorAll(
                                                  Object.keys(o.EMBED_TAGS).join(",")
                                              ).length),
                                          t);
                                }),
                                (t.prototype.merge = function (t) {
                                    var e;
                                    return (
                                        (e = o(t)),
                                        this.isElement()
                                            ? (e.moveChildren(this.node), this.normalize())
                                            : this.text(this.text() + e.text()),
                                        e.remove(),
                                        this
                                    );
                                }),
                                (t.prototype.moveChildren = function (t) {
                                    return (
                                        l.each(this.childNodes(), function (e) {
                                            return t.appendChild(e);
                                        }),
                                        this
                                    );
                                }),
                                (t.prototype.nextLineNode = function (t) {
                                    var e;
                                    return (
                                        null == (e = this.node.nextSibling) &&
                                            this.node.parentNode !== t &&
                                            (e = this.node.parentNode.nextSibling),
                                        null != e &&
                                            null != o.LIST_TAGS[e.tagName] &&
                                            (e = e.firstChild),
                                        e
                                    );
                                }),
                                (t.prototype.normalize = function () {
                                    var t, e, n, i;
                                    for (e = this.node.firstChild; null != e; )
                                        ((i = e.nextSibling),
                                            (t = o(e)),
                                            null != i &&
                                                o(i).isTextNode() &&
                                                (0 === t.text().length
                                                    ? t.remove()
                                                    : t.isTextNode() &&
                                                      ((n = i.nextSibling), t.merge(i), (i = n))),
                                            (e = i));
                                    return this;
                                }),
                                (t.prototype.on = function (t, e) {
                                    return (
                                        this.node.addEventListener(
                                            t,
                                            (function (n) {
                                                return function (i) {
                                                    var r, o;
                                                    return (
                                                        (r =
                                                            !s || ("keydown" !== t && "keyup" !== t)
                                                                ? i
                                                                : s),
                                                        (o = e.call(n.node, r)) ||
                                                            (i.preventDefault(), i.stopPropagation()),
                                                        o
                                                    );
                                                };
                                            })(this)
                                        ),
                                        this
                                    );
                                }),
                                (t.prototype.remove = function () {
                                    var t;
                                    return (
                                        null != (t = this.node.parentNode) && t.removeChild(this.node),
                                        (this.node = null),
                                        null
                                    );
                                }),
                                (t.prototype.removeClass = function (t) {
                                    var e;
                                    if (this.hasClass(t))
                                        return (
                                            null != this.node.classList
                                                ? this.node.classList.remove(t)
                                                : null != this.node.className &&
                                                  ((e = this.classes()).splice(e.indexOf(t), 1),
                                                  (this.node.className = e.join(" "))),
                                            this.node.getAttribute("class") ||
                                                this.node.removeAttribute("class"),
                                            this
                                        );
                                }),
                                (t.prototype.replace = function (t) {
                                    return (
                                        this.node.parentNode.replaceChild(t, this.node),
                                        (this.node = t),
                                        t
                                    );
                                }),
                                (t.prototype.splitAncestors = function (t, e) {
                                    var n, i, r, s;
                                    if (
                                        (null == e && (e = !1),
                                        this.node === t || this.node.parentNode === t)
                                    )
                                        return this;
                                    if (null != this.node.previousSibling || e) {
                                        for (
                                            i = (r = this.node.parentNode).cloneNode(!1),
                                                r.parentNode.insertBefore(i, r.nextSibling),
                                                s = this.node;
                                            null != s;

                                        )
                                            ((n = s.nextSibling), i.appendChild(s), (s = n));
                                        return o(i).splitAncestors(t);
                                    }
                                    return o(this.node.parentNode).splitAncestors(t);
                                }),
                                (t.prototype.split = function (t, e) {
                                    var n, i, r, s, l, u, a, c, h;
                                    if (
                                        (null == e && (e = !1),
                                        (u = this.length()),
                                        (t = Math.max(0, t)),
                                        (t = Math.min(t, u)),
                                        !e && 0 === t)
                                    )
                                        return [this.node.previousSibling, this.node, !1];
                                    if (!e && t === u) return [this.node, this.node.nextSibling, !1];
                                    if (this.node.nodeType === o.TEXT_NODE)
                                        return ((n = this.node.splitText(t)), [this.node, n, !0]);
                                    for (
                                        s = this.node,
                                            a = this.node.cloneNode(!1),
                                            this.node.parentNode.insertBefore(a, s.nextSibling),
                                            i = (c = this.child(t))[0],
                                            t = c[1],
                                            (h = o(i).split(t))[0],
                                            r = h[1];
                                        null !== r;

                                    )
                                        ((l = r.nextSibling), a.appendChild(r), (r = l));
                                    return [s, a, !0];
                                }),
                                (t.prototype.styles = function (t, e) {
                                    var n;
                                    return (
                                        null == e && (e = !1),
                                        t
                                            ? (e || (t = l.defaults(t, this.styles())),
                                              (n =
                                                  l
                                                      .map(t, function (t, e) {
                                                          return e + ": " + t;
                                                      })
                                                      .join("; ") + ";"),
                                              this.node.setAttribute("style", n),
                                              this)
                                            : ((n = this.node.getAttribute("style") || ""),
                                              l.reduce(
                                                  n.split(";"),
                                                  function (t, e) {
                                                      var n, i, r;
                                                      return (
                                                          (r = e.split(":")),
                                                          (n = r[0]),
                                                          (i = r[1]),
                                                          n &&
                                                              i &&
                                                              ((n = n.trim()),
                                                              (i = i.trim()),
                                                              (t[n.toLowerCase()] = i)),
                                                          t
                                                      );
                                                  },
                                                  {}
                                              ))
                                    );
                                }),
                                (t.prototype.switchTag = function (t) {
                                    var e, n;
                                    return (
                                        (t = t.toUpperCase()),
                                        this.node.tagName === t
                                            ? this
                                            : ((n = document.createElement(t)),
                                              (e = this.attributes()),
                                              null == o.VOID_TAGS[t] && this.moveChildren(n),
                                              this.replace(n),
                                              this.attributes(e).get())
                                    );
                                }),
                                (t.prototype.text = function (t) {
                                    if (null != t) {
                                        switch (this.node.nodeType) {
                                            case o.ELEMENT_NODE:
                                                this.node.textContent = t;
                                                break;
                                            case o.TEXT_NODE:
                                                this.node.data = t;
                                        }
                                        return this;
                                    }
                                    switch (this.node.nodeType) {
                                        case o.ELEMENT_NODE:
                                            return this.node.tagName === o.DEFAULT_BREAK_TAG
                                                ? ""
                                                : null != o.EMBED_TAGS[this.node.tagName]
                                                  ? o.EMBED_TEXT
                                                  : null != this.node.textContent
                                                    ? this.node.textContent
                                                    : "";
                                        case o.TEXT_NODE:
                                            return this.node.data || "";
                                        default:
                                            return "";
                                    }
                                }),
                                (t.prototype.textNodes = function () {
                                    var t, e, n;
                                    for (
                                        n = document.createTreeWalker(
                                            this.node,
                                            NodeFilter.SHOW_TEXT,
                                            null,
                                            !1
                                        ),
                                            e = [];
                                        (t = n.nextNode());

                                    )
                                        e.push(t);
                                    return e;
                                }),
                                (t.prototype.toggleClass = function (t, e) {
                                    return (
                                        null == e && (e = !this.hasClass(t)),
                                        e ? this.addClass(t) : this.removeClass(t),
                                        this
                                    );
                                }),
                                (t.prototype.trigger = function (t, e) {
                                    var n, i;
                                    return (
                                        null == e && (e = {}),
                                        ["keypress", "keydown", "keyup"].indexOf(t) < 0
                                            ? (n = document.createEvent("Event")).initEvent(
                                                  t,
                                                  e.bubbles,
                                                  e.cancelable
                                              )
                                            : ((n = document.createEvent("KeyboardEvent")),
                                              (s = l.clone(e)),
                                              l.isNumber(e.key)
                                                  ? (s.which = e.key)
                                                  : l.isString(e.key)
                                                    ? (s.which = e.key.toUpperCase().charCodeAt(0))
                                                    : (s.which = 0),
                                              o.isIE(10)
                                                  ? ((i = []),
                                                    e.altKey && i.push("Alt"),
                                                    e.ctrlKey && i.push("Control"),
                                                    e.metaKey && i.push("Meta"),
                                                    e.shiftKey && i.push("Shift"),
                                                    n.initKeyboardEvent(
                                                        t,
                                                        e.bubbles,
                                                        e.cancelable,
                                                        window,
                                                        0,
                                                        0,
                                                        i.join(" "),
                                                        null,
                                                        null
                                                    ))
                                                  : n[
                                                        l.isFunction(n.initKeyboardEvent)
                                                            ? "initKeyboardEvent"
                                                            : "initKeyEvent"
                                                    ](
                                                        t,
                                                        e.bubbles,
                                                        e.cancelable,
                                                        window,
                                                        e.ctrlKey,
                                                        e.altKey,
                                                        e.shiftKey,
                                                        e.metaKey,
                                                        0,
                                                        0
                                                    )),
                                        this.node.dispatchEvent(n),
                                        (s = null),
                                        this
                                    );
                                }),
                                (t.prototype.unwrap = function () {
                                    var t, e;
                                    return (
                                        (e = this.node.firstChild),
                                        (t = this.node.nextSibling),
                                        l.each(
                                            this.childNodes(),
                                            (function (e) {
                                                return function (n) {
                                                    return e.node.parentNode.insertBefore(n, t);
                                                };
                                            })(this)
                                        ),
                                        this.remove(),
                                        e
                                    );
                                }),
                                (t.prototype.wrap = function (t) {
                                    var e;
                                    for (
                                        null != this.node.parentNode &&
                                            this.node.parentNode.insertBefore(t, this.node),
                                            e = t;
                                        null != e.firstChild;

                                    )
                                        e = t.firstChild;
                                    return (e.appendChild(this.node), this);
                                }),
                                t
                            );
                        })()),
                        (i = (function (t) {
                            function e() {
                                return e.__super__.constructor.apply(this, arguments);
                            }
                            return (
                                c(e, t),
                                (e.prototype.default = function () {
                                    return this.node.querySelector("option[selected]");
                                }),
                                (e.prototype.option = function (t, e) {
                                    var n, i, r, o, s;
                                    if ((null == e && (e = !0), (i = l.isElement(t) ? t.value : t))) {
                                        for (
                                            i = i.replace(/[^\w]+/g, ""),
                                                n = r = 0,
                                                o = (s = this.node.children).length;
                                            r < o;
                                            n = ++r
                                        )
                                            if (s[n].value.replace(/[^\w]+/g, "") === i) {
                                                this.node.selectedIndex = n;
                                                break;
                                            }
                                    } else this.node.selectedIndex = -1;
                                    return (e && this.trigger("change"), this);
                                }),
                                (e.prototype.reset = function (t) {
                                    var e;
                                    return (
                                        null == t && (t = !0),
                                        (e = this.default()),
                                        null != e ? (e.selected = !0) : (this.node.selectedIndex = 0),
                                        t && this.trigger("change"),
                                        this
                                    );
                                }),
                                (e.prototype.value = function () {
                                    return this.node.selectedIndex > -1
                                        ? this.node.options[this.node.selectedIndex].value
                                        : "";
                                }),
                                e
                            );
                        })(r)),
                        (o = function (t) {
                            return "SELECT" === (null != t ? t.tagName : void 0) ? new i(t) : new r(t);
                        }),
                        (o = l.extend(o, {
                            ELEMENT_NODE: 1,
                            NOBREAK_SPACE: "&nbsp;",
                            TEXT_NODE: 3,
                            ZERO_WIDTH_NOBREAK_SPACE: "\ufeff",
                            DEFAULT_BLOCK_TAG: "DIV",
                            DEFAULT_BREAK_TAG: "BR",
                            DEFAULT_INLINE_TAG: "SPAN",
                            EMBED_TEXT: "!",
                            FONT_SIZES: {
                                "10px": 1,
                                "13px": 2,
                                "16px": 3,
                                "18px": 4,
                                "24px": 5,
                                "32px": 6,
                                "48px": 7
                            },
                            KEYS: {
                                BACKSPACE: 8,
                                TAB: 9,
                                ENTER: 13,
                                ESCAPE: 27,
                                LEFT: 37,
                                UP: 38,
                                RIGHT: 39,
                                DOWN: 40,
                                DELETE: 46
                            },
                            BLOCK_TAGS: {
                                ADDRESS: "ADDRESS",
                                ARTICLE: "ARTICLE",
                                ASIDE: "ASIDE",
                                AUDIO: "AUDIO",
                                BLOCKQUOTE: "BLOCKQUOTE",
                                CANVAS: "CANVAS",
                                DD: "DD",
                                DIV: "DIV",
                                DL: "DL",
                                FIGCAPTION: "FIGCAPTION",
                                FIGURE: "FIGURE",
                                FOOTER: "FOOTER",
                                FORM: "FORM",
                                H1: "H1",
                                H2: "H2",
                                H3: "H3",
                                H4: "H4",
                                H5: "H5",
                                H6: "H6",
                                HEADER: "HEADER",
                                HGROUP: "HGROUP",
                                LI: "LI",
                                OL: "OL",
                                OUTPUT: "OUTPUT",
                                P: "P",
                                PRE: "PRE",
                                SECTION: "SECTION",
                                TABLE: "TABLE",
                                TBODY: "TBODY",
                                TD: "TD",
                                TFOOT: "TFOOT",
                                TH: "TH",
                                THEAD: "THEAD",
                                TR: "TR",
                                UL: "UL",
                                VIDEO: "VIDEO"
                            },
                            EMBED_TAGS: { IMG: "IMG" },
                            LINE_TAGS: { DIV: "DIV", LI: "LI" },
                            LIST_TAGS: { OL: "OL", UL: "UL" },
                            VOID_TAGS: {
                                AREA: "AREA",
                                BASE: "BASE",
                                BR: "BR",
                                COL: "COL",
                                COMMAND: "COMMAND",
                                EMBED: "EMBED",
                                HR: "HR",
                                IMG: "IMG",
                                INPUT: "INPUT",
                                KEYGEN: "KEYGEN",
                                LINK: "LINK",
                                META: "META",
                                PARAM: "PARAM",
                                SOURCE: "SOURCE",
                                TRACK: "TRACK",
                                WBR: "WBR"
                            },
                            convertFontSize: function (t) {
                                var e, n, i, r;
                                l.isString(t) && t.indexOf("px") > -1
                                    ? ((i = Object.keys(o.FONT_SIZES)), (r = l.values(o.FONT_SIZES)))
                                    : ((r = Object.keys(o.FONT_SIZES)), (i = l.values(o.FONT_SIZES)));
                                for (e in i) if (((n = i[e]), parseInt(t) <= parseInt(n))) return r[e];
                                return l.last(r);
                            },
                            isIE: function (t) {
                                var e;
                                return (e = document.documentMode) && t >= e;
                            },
                            isIOS: function () {
                                return /iPhone|iPad/i.test(navigator.userAgent);
                            },
                            isMac: function () {
                                return /Mac/i.test(navigator.platform);
                            }
                        })),
                        (e.exports = o));
                },
                { lodash: 1 }
            ],
            17: [
                function (t, e, n) {
                    var i, r;
                    ((r = (function () {
                        return function (t) {
                            ((this.data = t), (this.prev = this.next = null));
                        };
                    })()),
                        (i = (function () {
                            function t() {
                                ((this.length = 0), (this.first = this.last = null));
                            }
                            return (
                                (t.Node = r),
                                (t.prototype.append = function (t) {
                                    return (
                                        null != this.first
                                            ? ((t.next = null), (this.last.next = t))
                                            : (this.first = t),
                                        (t.prev = this.last),
                                        (this.last = t),
                                        (this.length += 1)
                                    );
                                }),
                                (t.prototype.insertAfter = function (t, e) {
                                    return (
                                        (e.prev = t),
                                        null != t
                                            ? ((e.next = t.next),
                                              null != t.next && (t.next.prev = e),
                                              (t.next = e),
                                              t === this.last && (this.last = e))
                                            : ((e.next = this.first),
                                              (this.first.prev = e),
                                              (this.first = e)),
                                        (this.length += 1)
                                    );
                                }),
                                (t.prototype.remove = function (t) {
                                    return (
                                        this.length > 1
                                            ? (null != t.prev && (t.prev.next = t.next),
                                              null != t.next && (t.next.prev = t.prev),
                                              t === this.first && (this.first = t.next),
                                              t === this.last && (this.last = t.prev))
                                            : (this.first = this.last = null),
                                        (t.prev = t.next = null),
                                        (this.length -= 1)
                                    );
                                }),
                                (t.prototype.toArray = function () {
                                    var t, e;
                                    for (t = [], e = this.first; null != e; ) (t.push(e), (e = e.next));
                                    return t;
                                }),
                                t
                            );
                        })()),
                        (e.exports = i));
                },
                {}
            ],
            18: [
                function (t, e, n) {
                    var i, r, o;
                    ((o = t("lodash")),
                        (r = t("./dom")),
                        (i = {
                            ALIASES: { STRONG: "B", EM: "I", DEL: "S", STRIKE: "S" },
                            ATTRIBUTES: { color: "color", face: "fontFamily", size: "fontSize" },
                            STYLES: {
                                "background-color": "background-color",
                                color: "color",
                                "font-family": "font-family",
                                "font-size": "font-size",
                                "text-align": "text-align"
                            },
                            TAGS: {
                                DIV: "DIV",
                                BR: "BR",
                                SPAN: "SPAN",
                                B: "B",
                                I: "I",
                                S: "S",
                                U: "U",
                                A: "A",
                                IMG: "IMG",
                                OL: "OL",
                                UL: "UL",
                                LI: "LI"
                            },
                            handleBreaks: function (t) {
                                var e;
                                return (
                                    (e = o.map(t.querySelectorAll(r.DEFAULT_BREAK_TAG))),
                                    o.each(e, function (e) {
                                        if (
                                            null != e.nextSibling &&
                                            (!r.isIE(10) || null != e.previousSibling)
                                        )
                                            return r(e.nextSibling).splitAncestors(t.parentNode);
                                    }),
                                    t
                                );
                            },
                            normalizeLine: function (t) {
                                return (
                                    (t = i.wrapInline(t)),
                                    (t = i.handleBreaks(t)),
                                    (t = i.pullBlocks(t)),
                                    (t = i.normalizeNode(t)),
                                    i.unwrapText(t),
                                    null != t && null != r.LIST_TAGS[t.tagName] && (t = t.firstChild),
                                    t
                                );
                            },
                            normalizeNode: function (t) {
                                return r(t).isTextNode()
                                    ? t
                                    : (o.each(i.ATTRIBUTES, function (e, n) {
                                          var i;
                                          if (t.hasAttribute(n))
                                              return (
                                                  (i = t.getAttribute(n)),
                                                  "size" === n && (i = r.convertFontSize(i)),
                                                  (t.style[e] = i),
                                                  t.removeAttribute(n)
                                              );
                                      }),
                                      i.whitelistStyles(t),
                                      i.whitelistTags(t));
                            },
                            optimizeLine: function (t) {
                                var e, n, i, s;
                                for (
                                    t.normalize(), e = r(t).length(), i = r(t).descendants(), s = [];
                                    i.length > 0;

                                )
                                    null != (null != (n = i.pop()) ? n.parentNode : void 0) &&
                                        null == r.EMBED_TAGS[n.tagName] &&
                                        (n.tagName === r.DEFAULT_BREAK_TAG
                                            ? 0 !== e
                                                ? s.push(r(n).remove())
                                                : s.push(void 0)
                                            : 0 === r(n).length()
                                              ? (i.push(n.nextSibling), s.push(r(n).unwrap()))
                                              : null != n.previousSibling &&
                                                  n.tagName === n.previousSibling.tagName &&
                                                  o.isEqual(
                                                      r(n).attributes(),
                                                      r(n.previousSibling).attributes()
                                                  )
                                                ? (i.push(n.firstChild),
                                                  s.push(r(n.previousSibling).merge(n)))
                                                : s.push(void 0));
                                return s;
                            },
                            pullBlocks: function (t) {
                                var e;
                                for (e = t.firstChild; null != e; ) {
                                    if (null != r.BLOCK_TAGS[e.tagName] && "LI" !== e.tagName) {
                                        (null != e.previousSibling && r(e).splitAncestors(t.parentNode),
                                            null != e.nextSibling &&
                                                r(e.nextSibling).splitAncestors(t.parentNode),
                                            null != r.LIST_TAGS[e.tagName] && e.firstChild
                                                ? (r(e.parentNode).unwrap(),
                                                  null == t.parentNode && (t = e))
                                                : (r(e).unwrap(), i.pullBlocks(t)));
                                        break;
                                    }
                                    e = e.nextSibling;
                                }
                                return t;
                            },
                            stripComments: function (t) {
                                return t.replace(/<!--[\s\S]*?-->/g, "");
                            },
                            stripWhitespace: function (t) {
                                return (
                                    (t = t.trim()),
                                    (t = t.replace(/(\r?\n|\r)+/g, " ")),
                                    (t = t.replace(/\>\s+\</g, "><"))
                                );
                            },
                            whitelistStyles: function (t) {
                                var e, n;
                                if (
                                    ((e = r(t).styles()),
                                    (n = o.omit(e, function (t, e) {
                                        return null == i.STYLES[e];
                                    })),
                                    Object.keys(n).length < Object.keys(e).length)
                                )
                                    return Object.keys(n).length > 0
                                        ? r(t).styles(n, !0)
                                        : t.removeAttribute("style");
                            },
                            whitelistTags: function (t) {
                                return r(t).isElement()
                                    ? (null != i.ALIASES[t.tagName]
                                          ? (t = r(t).switchTag(i.ALIASES[t.tagName]))
                                          : null == i.TAGS[t.tagName] &&
                                            (t =
                                                null != r.BLOCK_TAGS[t.tagName]
                                                    ? r(t).switchTag(r.DEFAULT_BLOCK_TAG)
                                                    : t.hasAttributes() || null == t.firstChild
                                                      ? r(t).switchTag(r.DEFAULT_INLINE_TAG)
                                                      : r(t).unwrap()),
                                      t)
                                    : t;
                            },
                            wrapInline: function (t) {
                                var e, n;
                                if (null != r.BLOCK_TAGS[t.tagName]) return t;
                                for (
                                    e = document.createElement(r.DEFAULT_BLOCK_TAG),
                                        t.parentNode.insertBefore(e, t);
                                    null != t && null == r.BLOCK_TAGS[t.tagName];

                                )
                                    ((n = t.nextSibling), e.appendChild(t), (t = n));
                                return e;
                            },
                            unwrapText: function (t) {
                                var e;
                                return (
                                    (e = o.map(t.querySelectorAll(r.DEFAULT_INLINE_TAG))),
                                    o.each(e, function (t) {
                                        if (!t.hasAttributes()) return r(t).unwrap();
                                    })
                                );
                            }
                        }),
                        (e.exports = i));
                },
                { "./dom": 16, lodash: 1 }
            ],
            19: [
                function (t, e, n) {
                    var i, r, o, s;
                    ((s = t("lodash")),
                        (o = t("./dom")),
                        (i = t("./normalizer")),
                        (r = (function () {
                            function t(t) {
                                ((this.select = t),
                                    (this.container = document.createElement("span")),
                                    this.buildPicker(),
                                    o(this.container).addClass("ql-picker"),
                                    (this.select.style.display = "none"),
                                    this.select.parentNode.insertBefore(this.container, this.select),
                                    o(document).on(
                                        "click",
                                        (function (t) {
                                            return function () {
                                                return (t.close(), !0);
                                            };
                                        })(this)
                                    ),
                                    o(this.label).on(
                                        "click",
                                        (function (t) {
                                            return function () {
                                                return (
                                                    s.defer(function () {
                                                        return o(t.container).toggleClass(
                                                            "ql-expanded"
                                                        );
                                                    }),
                                                    !1
                                                );
                                            };
                                        })(this)
                                    ),
                                    o(this.select).on(
                                        "change",
                                        (function (t) {
                                            return function () {
                                                var e, n;
                                                return (
                                                    t.select.selectedIndex > -1 &&
                                                        ((e =
                                                            t.container.querySelectorAll(
                                                                ".ql-picker-item"
                                                            )[t.select.selectedIndex]),
                                                        (n = t.select.options[t.select.selectedIndex])),
                                                    t.selectItem(e, !1),
                                                    o(t.label).toggleClass(
                                                        "ql-active",
                                                        n !== o(t.select).default()
                                                    )
                                                );
                                            };
                                        })(this)
                                    ));
                            }
                            return (
                                (t.TEMPLATE =
                                    '<span class="ql-picker-label"></span><span class="ql-picker-options"></span>'),
                                (t.prototype.buildItem = function (t, e, n) {
                                    var i;
                                    return (
                                        (i = document.createElement("span")).setAttribute(
                                            "data-value",
                                            e.getAttribute("value")
                                        ),
                                        o(i)
                                            .addClass("ql-picker-item")
                                            .text(o(e).text())
                                            .on(
                                                "click",
                                                (function (t) {
                                                    return function () {
                                                        return (t.selectItem(i, !0), t.close());
                                                    };
                                                })(this)
                                            ),
                                        this.select.selectedIndex === n && this.selectItem(i, !1),
                                        i
                                    );
                                }),
                                (t.prototype.buildPicker = function () {
                                    var e;
                                    return (
                                        s.each(
                                            o(this.select).attributes(),
                                            (function (t) {
                                                return function (e, n) {
                                                    return t.container.setAttribute(n, e);
                                                };
                                            })(this)
                                        ),
                                        (this.container.innerHTML = i.stripWhitespace(t.TEMPLATE)),
                                        (this.label = this.container.querySelector(".ql-picker-label")),
                                        (e = this.container.querySelector(".ql-picker-options")),
                                        s.each(
                                            this.select.options,
                                            (function (t) {
                                                return function (n, i) {
                                                    var r;
                                                    return (
                                                        (r = t.buildItem(e, n, i)),
                                                        e.appendChild(r)
                                                    );
                                                };
                                            })(this)
                                        )
                                    );
                                }),
                                (t.prototype.close = function () {
                                    return o(this.container).removeClass("ql-expanded");
                                }),
                                (t.prototype.selectItem = function (t, e) {
                                    var n, i;
                                    return (
                                        null != (n = this.container.querySelector(".ql-selected")) &&
                                            o(n).removeClass("ql-selected"),
                                        null != t
                                            ? ((i = t.getAttribute("data-value")),
                                              o(t).addClass("ql-selected"),
                                              o(this.label).text(o(t).text()),
                                              o(this.select).option(i, e),
                                              this.label.setAttribute("data-value", i))
                                            : ((this.label.innerHTML = "&nbsp;"),
                                              this.label.removeAttribute("data-value"))
                                    );
                                }),
                                t
                            );
                        })()),
                        (e.exports = r));
                },
                { "./dom": 16, "./normalizer": 18, lodash: 1 }
            ],
            20: [
                function (t, e, n) {
                    var i, r;
                    ((r = t("lodash")),
                        (i = (function () {
                            function t(t, e) {
                                ((this.start = t), (this.end = e));
                            }
                            return (
                                (t.compare = function (t, e) {
                                    return t === e || (null != t && null != e && t.equals(e));
                                }),
                                (t.prototype.equals = function (t) {
                                    return null != t && this.start === t.start && this.end === t.end;
                                }),
                                (t.prototype.shift = function (t, e) {
                                    var n;
                                    return (
                                        (n = r.map([this.start, this.end], function (n) {
                                            return t > n ? n : e >= 0 ? n + e : Math.max(t, n + e);
                                        })),
                                        (this.start = n[0]),
                                        (this.end = n[1]),
                                        n
                                    );
                                }),
                                (t.prototype.isCollapsed = function () {
                                    return this.start === this.end;
                                }),
                                t
                            );
                        })()),
                        (e.exports = i));
                },
                { lodash: 1 }
            ],
            21: [
                function (t, e, n) {
                    var i, r, o, s, l;
                    ((o = t("../quill")),
                        (l = o.require("lodash")),
                        (s = o.require("dom")),
                        (r = o.require("delta")),
                        (i = (function () {
                            function t(t, e) {
                                ((this.quill = t),
                                    (this.options = e),
                                    null != this.options.button &&
                                        this.attachButton(this.options.button),
                                    this.options.enabled && this.enable(),
                                    this.quill.addFormat("author", { class: "author-" }),
                                    null != this.options.authorId &&
                                        (this.quill.on(
                                            this.quill.constructor.events.PRE_EVENT,
                                            (function (t) {
                                                return function (e, n, i) {
                                                    var s, u;
                                                    if (
                                                        e === t.quill.constructor.events.TEXT_CHANGE &&
                                                        "user" === i
                                                    )
                                                        return (
                                                            (s = new r()),
                                                            (u = { author: t.options.authorId }),
                                                            l.each(n.ops, function (e) {
                                                                if (null == e.delete)
                                                                    return null != e.insert ||
                                                                        (null != e.retain &&
                                                                            null != e.attributes)
                                                                        ? (e.attributes ||
                                                                              (e.attributes = {}),
                                                                          (e.attributes.author =
                                                                              t.options.authorId),
                                                                          s.retain(
                                                                              e.retain ||
                                                                                  e.insert.length ||
                                                                                  1,
                                                                              u
                                                                          ))
                                                                        : s.retain(e.retain);
                                                            }),
                                                            t.quill.updateContents(s, o.sources.SILENT)
                                                        );
                                                };
                                            })(this)
                                        ),
                                        this.addAuthor(this.options.authorId, this.options.color)));
                            }
                            return (
                                (t.DEFAULTS = { authorId: null, color: "transparent", enabled: !1 }),
                                (t.prototype.addAuthor = function (t, e) {
                                    var n;
                                    return (
                                        (n = {}),
                                        (n[".authorship .author-" + t] = {
                                            "background-color": "" + e
                                        }),
                                        this.quill.theme.addStyles(n)
                                    );
                                }),
                                (t.prototype.attachButton = function (t) {
                                    var e;
                                    return (e = s(t)).on(
                                        "click",
                                        (function (t) {
                                            return function () {
                                                return (
                                                    e.toggleClass("ql-on"),
                                                    t.enable($dom.hasClass("ql-on"))
                                                );
                                            };
                                        })(this)
                                    );
                                }),
                                (t.prototype.enable = function (t) {
                                    return (
                                        null == t && (t = !0),
                                        s(this.quill.root).toggleClass("authorship", t)
                                    );
                                }),
                                (t.prototype.disable = function () {
                                    return this.enable(!1);
                                }),
                                t
                            );
                        })()),
                        o.registerModule("authorship", i),
                        (e.exports = i));
                },
                { "../quill": 30 }
            ],
            22: [
                function (t, e, n) {
                    var i,
                        r,
                        o,
                        s,
                        l,
                        u = {}.hasOwnProperty,
                        a = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) u.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        };
                    ((r = t("../quill")),
                        (o = t("./tooltip")),
                        (l = r.require("lodash")),
                        (s = r.require("dom")),
                        r.require("delta"),
                        (i = (function (t) {
                            function e(t, n) {
                                ((this.quill = t),
                                    (this.options = n),
                                    (this.options = l.defaults(this.options, o.DEFAULTS)),
                                    e.__super__.constructor.call(this, this.quill, this.options),
                                    (this.preview = this.container.querySelector(".preview")),
                                    (this.textbox = this.container.querySelector(".input")),
                                    s(this.container).addClass("ql-image-tooltip"),
                                    this.initListeners());
                            }
                            return (
                                a(e, t),
                                (e.DEFAULTS = {
                                    template:
                                        '<input class="input" type="textbox"> <div class="preview"> <span>Preview</span> </div> <a href="javascript:;" class="cancel">Cancel</a> <a href="javascript:;" class="insert">Insert</a>'
                                }),
                                (e.prototype.initListeners = function () {
                                    return (
                                        s(this.container.querySelector(".insert")).on(
                                            "click",
                                            l.bind(this.insertImage, this)
                                        ),
                                        s(this.container.querySelector(".cancel")).on(
                                            "click",
                                            l.bind(this.hide, this)
                                        ),
                                        s(this.textbox).on("input", l.bind(this._preview, this)),
                                        this.initTextbox(this.textbox, this.insertImage, this.hide),
                                        this.quill.onModuleLoad(
                                            "toolbar",
                                            (function (t) {
                                                return function (e) {
                                                    return e.initFormat(
                                                        "image",
                                                        l.bind(t._onToolbar, t)
                                                    );
                                                };
                                            })(this)
                                        )
                                    );
                                }),
                                (e.prototype.insertImage = function () {
                                    var t, e;
                                    return (
                                        (e = this._normalizeURL(this.textbox.value)),
                                        null == this.range && (this.range = new Range(0, 0)),
                                        this.range &&
                                            ((this.preview.innerHTML = "<span>Preview</span>"),
                                            (this.textbox.value = ""),
                                            (t = this.range.end),
                                            this.quill.insertEmbed(t, "image", e, "user"),
                                            this.quill.setSelection(t + 1, t + 1)),
                                        this.hide()
                                    );
                                }),
                                (e.prototype._onToolbar = function (t, e) {
                                    return e
                                        ? (this.textbox.value || (this.textbox.value = "http://"),
                                          this.show(),
                                          this.textbox.focus(),
                                          l.defer(
                                              (function (t) {
                                                  return function () {
                                                      return t.textbox.setSelectionRange(
                                                          t.textbox.value.length,
                                                          t.textbox.value.length
                                                      );
                                                  };
                                              })(this)
                                          ))
                                        : this.quill.deleteText(t, "user");
                                }),
                                (e.prototype._preview = function () {
                                    var t;
                                    if (this._matchImageURL(this.textbox.value))
                                        return "IMG" === this.preview.firstChild.tagName
                                            ? this.preview.firstChild.setAttribute(
                                                  "src",
                                                  this.textbox.value
                                              )
                                            : ((t = document.createElement("img")).setAttribute(
                                                  "src",
                                                  this.textbox.value
                                              ),
                                              this.preview.replaceChild(t, this.preview.firstChild));
                                }),
                                (e.prototype._matchImageURL = function (t) {
                                    return /^https?:\/\/.+\.(jpe?g|gif|png)$/.test(t);
                                }),
                                (e.prototype._normalizeURL = function (t) {
                                    return (/^https?:\/\//.test(t) || (t = "http://" + t), t);
                                }),
                                e
                            );
                        })(o)),
                        r.registerModule("image-tooltip", i),
                        (e.exports = i));
                },
                { "../quill": 30, "./tooltip": 28 }
            ],
            23: [
                function (t, e, n) {
                    var i, r, o, s, l;
                    ((o = t("../quill")),
                        (l = o.require("lodash")),
                        (s = o.require("dom")),
                        (i = o.require("delta")),
                        (r = (function () {
                            function t(t, e) {
                                ((this.quill = t),
                                    (this.hotkeys = {}),
                                    this._initListeners(),
                                    this._initHotkeys(),
                                    this._initDeletes());
                            }
                            return (
                                (t.hotkeys = {
                                    BOLD: { key: "B", metaKey: !0 },
                                    INDENT: { key: s.KEYS.TAB },
                                    ITALIC: { key: "I", metaKey: !0 },
                                    OUTDENT: { key: s.KEYS.TAB, shiftKey: !0 },
                                    UNDERLINE: { key: "U", metaKey: !0 }
                                }),
                                (t.prototype.addHotkey = function (t, e) {
                                    return (
                                        Array.isArray(t) || (t = [t]),
                                        l.each(
                                            t,
                                            (function (t) {
                                                return function (n) {
                                                    var i, r;
                                                    return (
                                                        (n = l.isObject(n) ? l.clone(n) : { key: n }),
                                                        (n.callback = e),
                                                        (i = l.isNumber(n.key)
                                                            ? n.key
                                                            : n.key.toUpperCase().charCodeAt(0)),
                                                        null == (r = t.hotkeys)[i] && (r[i] = []),
                                                        t.hotkeys[i].push(n)
                                                    );
                                                };
                                            })(this)
                                        )
                                    );
                                }),
                                (t.prototype.toggleFormat = function (t, e) {
                                    var n, i, r;
                                    if (
                                        ((n = t.isCollapsed()
                                            ? this.quill.getContents(Math.max(0, t.start - 1), t.end)
                                            : this.quill.getContents(t)),
                                        (r =
                                            0 === n.ops.length ||
                                            !l.all(n.ops, function (t) {
                                                var n;
                                                return null != (n = t.attributes) ? n[e] : void 0;
                                            })),
                                        t.isCollapsed()
                                            ? this.quill.prepareFormat(e, r)
                                            : this.quill.formatText(t, e, r, o.sources.USER),
                                        null != (i = this.quill.getModule("toolbar")))
                                    )
                                        return i.setActive(e, r);
                                }),
                                (t.prototype._initDeletes = function () {
                                    return this.addHotkey(
                                        [s.KEYS.DELETE, s.KEYS.BACKSPACE],
                                        (function (t) {
                                            return function (e, n) {
                                                var i;
                                                return (
                                                    null != e &&
                                                        t.quill.getLength() > 1 &&
                                                        (e.start !== e.end
                                                            ? t.quill.deleteText(
                                                                  e.start,
                                                                  e.end,
                                                                  o.sources.USER
                                                              )
                                                            : (i =
                                                                  n.key === s.KEYS.BACKSPACE
                                                                      ? e.start - 1
                                                                      : e.start) >= 0 &&
                                                              t.quill.deleteText(
                                                                  i,
                                                                  i + 1,
                                                                  o.sources.USER
                                                              )),
                                                    !1
                                                );
                                            };
                                        })(this)
                                    );
                                }),
                                (t.prototype._initHotkeys = function () {
                                    return (
                                        this.addHotkey(
                                            t.hotkeys.INDENT,
                                            (function (t) {
                                                return function (e) {
                                                    return (t._onTab(e, !1), !1);
                                                };
                                            })(this)
                                        ),
                                        this.addHotkey(t.hotkeys.OUTDENT, function (t) {
                                            return !1;
                                        }),
                                        l.each(
                                            ["bold", "italic", "underline"],
                                            (function (e) {
                                                return function (n) {
                                                    return e.addHotkey(
                                                        t.hotkeys[n.toUpperCase()],
                                                        function (t) {
                                                            return (e.toggleFormat(t, n), !1);
                                                        }
                                                    );
                                                };
                                            })(this)
                                        )
                                    );
                                }),
                                (t.prototype._initListeners = function () {
                                    return s(this.quill.root).on(
                                        "keydown",
                                        (function (t) {
                                            return function (e) {
                                                var n;
                                                return (
                                                    (n = !1),
                                                    l.each(t.hotkeys[e.which], function (i) {
                                                        var r;
                                                        if (
                                                            ((r = s.isMac()
                                                                ? e.metaKey
                                                                : e.metaKey || e.ctrlKey),
                                                            !!i.metaKey == !!r &&
                                                                !!i.shiftKey == !!e.shiftKey &&
                                                                !!i.altKey == !!e.altKey)
                                                        )
                                                            return (
                                                                (n =
                                                                    !1 ===
                                                                        i.callback(
                                                                            t.quill.getSelection(),
                                                                            i,
                                                                            e
                                                                        ) || n),
                                                                !0
                                                            );
                                                    }),
                                                    !n
                                                );
                                            };
                                        })(this)
                                    );
                                }),
                                (t.prototype._onTab = function (t, e) {
                                    var n;
                                    return (
                                        null == e && (e = !1),
                                        (n = new i()
                                            .retain(t.start)
                                            .insert("\t")
                                            .delete(t.end - t.start)
                                            .retain(this.quill.getLength() - t.end)),
                                        this.quill.updateContents(n, o.sources.USER),
                                        this.quill.setSelection(t.start + 1, t.start + 1)
                                    );
                                }),
                                t
                            );
                        })()),
                        o.registerModule("keyboard", r),
                        (e.exports = r));
                },
                { "../quill": 30 }
            ],
            24: [
                function (t, e, n) {
                    var i,
                        r,
                        o,
                        s,
                        l,
                        u = {}.hasOwnProperty,
                        a = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) u.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        };
                    ((r = t("../quill")),
                        (o = t("./tooltip")),
                        (l = r.require("lodash")),
                        (s = r.require("dom")),
                        (i = (function (t) {
                            function e(t, n) {
                                ((this.quill = t),
                                    (this.options = n),
                                    (this.options = l.defaults(this.options, o.DEFAULTS)),
                                    e.__super__.constructor.call(this, this.quill, this.options),
                                    s(this.container).addClass("ql-link-tooltip"),
                                    (this.textbox = this.container.querySelector(".input")),
                                    (this.link = this.container.querySelector(".url")),
                                    this.initListeners());
                            }
                            return (
                                a(e, t),
                                (e.DEFAULTS = {
                                    maxLength: 50,
                                    template:
                                        '<span class="title">Visit URL:&nbsp;</span> <a href="#" class="url" target="_blank" href="about:blank"></a> <input class="input" type="text"> <span>&nbsp;&#45;&nbsp;</span> <a href="javascript:;" class="change">Change</a> <a href="javascript:;" class="done">Done</a>'
                                }),
                                (e.prototype.initListeners = function () {
                                    return (
                                        this.quill.on(
                                            this.quill.constructor.events.SELECTION_CHANGE,
                                            (function (t) {
                                                return function (e) {
                                                    var n;
                                                    if (null != e && e.isCollapsed())
                                                        return (
                                                            (n = t._findAnchor(e)),
                                                            n
                                                                ? (t.setMode(n.href, !1), t.show(n))
                                                                : ((t.range = null), t.hide())
                                                        );
                                                };
                                            })(this)
                                        ),
                                        s(this.container.querySelector(".done")).on(
                                            "click",
                                            l.bind(this.saveLink, this)
                                        ),
                                        s(this.container.querySelector(".change")).on(
                                            "click",
                                            (function (t) {
                                                return function () {
                                                    return t.setMode(t.link.href, !0);
                                                };
                                            })(this)
                                        ),
                                        this.initTextbox(this.textbox, this.saveLink, this.hide),
                                        this.quill.onModuleLoad(
                                            "toolbar",
                                            (function (t) {
                                                return function (e) {
                                                    return e.initFormat(
                                                        "link",
                                                        l.bind(t._onToolbar, t)
                                                    );
                                                };
                                            })(this)
                                        )
                                    );
                                }),
                                (e.prototype.saveLink = function () {
                                    var t, e;
                                    return (
                                        (e = this._normalizeURL(this.textbox.value)),
                                        null != this.range &&
                                            (this.range.isCollapsed()
                                                ? null != (t = this._findAnchor(this.range)) &&
                                                  (t.href = e)
                                                : this.quill.formatText(this.range, "link", e, "user")),
                                        this.setMode(e, !1)
                                    );
                                }),
                                (e.prototype.setMode = function (t, e) {
                                    var n;
                                    return (
                                        null == e && (e = !1),
                                        e
                                            ? ((this.textbox.value = t),
                                              l.defer(
                                                  (function (e) {
                                                      return function () {
                                                          return (
                                                              e.textbox.focus(),
                                                              e.textbox.setSelectionRange(
                                                                  t.length,
                                                                  t.length
                                                              )
                                                          );
                                                      };
                                                  })(this)
                                              ))
                                            : ((this.link.href = t),
                                              (n =
                                                  t.length > this.options.maxLength
                                                      ? t.slice(0, this.options.maxLength) + "..."
                                                      : t),
                                              s(this.link).text(n)),
                                        s(this.container).toggleClass("editing", e)
                                    );
                                }),
                                (e.prototype._findAnchor = function (t) {
                                    var e, n, i;
                                    for (
                                        e = (i = this.quill.editor.doc.findLeafAt(t.start, !0))[0],
                                            i[1],
                                            null != e && (n = e.node);
                                        null != n;

                                    ) {
                                        if ("A" === n.tagName) return n;
                                        n = n.parentNode;
                                    }
                                    return null;
                                }),
                                (e.prototype._onToolbar = function (t, e) {
                                    var n;
                                    if (t && !t.isCollapsed())
                                        return e
                                            ? (this.setMode(this._suggestURL(t), !0),
                                              (n = this.quill.editor.selection._getNativeRange()),
                                              this.show(n))
                                            : this.quill.formatText(t, "link", !1, "user");
                                }),
                                (e.prototype._normalizeURL = function (t) {
                                    return (/^(https?:\/\/|mailto:)/.test(t) || (t = "http://" + t), t);
                                }),
                                (e.prototype._suggestURL = function (t) {
                                    var e;
                                    return ((e = this.quill.getText(t)), this._normalizeURL(e));
                                }),
                                e
                            );
                        })(o)),
                        r.registerModule("link-tooltip", i),
                        (e.exports = i));
                },
                { "../quill": 30, "./tooltip": 28 }
            ],
            25: [
                function (t, e, n) {
                    var i,
                        r,
                        o,
                        s,
                        l,
                        u = {}.hasOwnProperty,
                        a = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) u.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        };
                    ((o = t("../quill")),
                        (i = t("eventemitter2").EventEmitter2),
                        (l = o.require("lodash")),
                        (s = o.require("dom")),
                        (r = (function (t) {
                            function e(t, e) {
                                ((this.quill = t),
                                    (this.options = e),
                                    (this.cursors = {}),
                                    (this.container = this.quill.addContainer("ql-multi-cursor", !0)),
                                    this.quill.on(
                                        this.quill.constructor.events.TEXT_CHANGE,
                                        l.bind(this._applyDelta, this)
                                    ));
                            }
                            return (
                                a(e, t),
                                (e.DEFAULTS = {
                                    template:
                                        '<span class="cursor-flag"> <span class="cursor-name"></span> </span> <span class="cursor-caret"></span>',
                                    timeout: 2500
                                }),
                                (e.events = {
                                    CURSOR_ADDED: "cursor-addded",
                                    CURSOR_MOVED: "cursor-moved",
                                    CURSOR_REMOVED: "cursor-removed"
                                }),
                                (e.prototype.clearCursors = function () {
                                    return (
                                        l.each(
                                            Object.keys(this.cursors),
                                            l.bind(this.removeCursor, this)
                                        ),
                                        (this.cursors = {})
                                    );
                                }),
                                (e.prototype.moveCursor = function (t, e) {
                                    var n;
                                    return (
                                        (n = this.cursors[t]),
                                        (n.index = e),
                                        s(n.elem).removeClass("hidden"),
                                        clearTimeout(n.timer),
                                        (n.timer = setTimeout(function () {
                                            return (s(n.elem).addClass("hidden"), (n.timer = null));
                                        }, this.options.timeout)),
                                        this._updateCursor(n),
                                        n
                                    );
                                }),
                                (e.prototype.removeCursor = function (t) {
                                    var n;
                                    return (
                                        (n = this.cursors[t]),
                                        this.emit(e.events.CURSOR_REMOVED, n),
                                        null != n && n.elem.parentNode.removeChild(n.elem),
                                        delete this.cursors[t]
                                    );
                                }),
                                (e.prototype.setCursor = function (t, n, i, r) {
                                    var o;
                                    return (
                                        null == this.cursors[t] &&
                                            ((this.cursors[t] = o =
                                                {
                                                    userId: t,
                                                    index: n,
                                                    color: r,
                                                    elem: this._buildCursor(i, r)
                                                }),
                                            this.emit(e.events.CURSOR_ADDED, o)),
                                        l.defer(
                                            (function (e) {
                                                return function () {
                                                    return e.moveCursor(t, n);
                                                };
                                            })(this)
                                        ),
                                        this.cursors[t]
                                    );
                                }),
                                (e.prototype.shiftCursors = function (t, e, n) {
                                    return (
                                        null == n && (n = null),
                                        l.each(this.cursors, function (i, r) {
                                            if (i && (i.index > t || i.userId === n))
                                                return (i.index += Math.max(e, t - i.index));
                                        })
                                    );
                                }),
                                (e.prototype.update = function () {
                                    return l.each(
                                        this.cursors,
                                        (function (t) {
                                            return function (e, n) {
                                                if (null != e) return (t._updateCursor(e), !0);
                                            };
                                        })(this)
                                    );
                                }),
                                (e.prototype._applyDelta = function (t) {
                                    var e;
                                    return (
                                        (e = 0),
                                        l.each(
                                            t.ops,
                                            (function (t) {
                                                return function (n) {
                                                    var i, r;
                                                    return (
                                                        (i = 0),
                                                        null != n.insert
                                                            ? ((i = n.insert.length || 1),
                                                              t.shiftCursors(
                                                                  e,
                                                                  i,
                                                                  null != (r = n.attributes)
                                                                      ? r.author
                                                                      : void 0
                                                              ))
                                                            : null != n.delete
                                                              ? t.shiftCursors(e, -1 * n.delete, null)
                                                              : null != n.retain &&
                                                                (t.shiftCursors(e, 0, null),
                                                                (i = n.retain)),
                                                        (e += i)
                                                    );
                                                };
                                            })(this)
                                        ),
                                        this.update()
                                    );
                                }),
                                (e.prototype._buildCursor = function (t, e) {
                                    var n, i, r;
                                    return (
                                        (n = document.createElement("span")),
                                        s(n).addClass("cursor"),
                                        (n.innerHTML = this.options.template),
                                        n.querySelector(".cursor-flag"),
                                        (r = n.querySelector(".cursor-name")),
                                        s(r).text(t),
                                        (i = n.querySelector(".cursor-caret")),
                                        (i.style.backgroundColor = r.style.backgroundColor = e),
                                        this.container.appendChild(n),
                                        n
                                    );
                                }),
                                (e.prototype._updateCursor = function (t) {
                                    var n, i;
                                    return (
                                        (n = this.quill.getBounds(t.index)),
                                        (t.elem.style.top =
                                            n.top - this.quill.container.scrollTop + "px"),
                                        (t.elem.style.left = n.left + "px"),
                                        (t.elem.style.height = n.height + "px"),
                                        (i = t.elem.querySelector(".cursor-flag")),
                                        s(t.elem)
                                            .toggleClass(
                                                "top",
                                                parseInt(t.elem.style.top) <= i.offsetHeight
                                            )
                                            .toggleClass(
                                                "left",
                                                parseInt(t.elem.style.left) <= i.offsetWidth
                                            )
                                            .toggleClass(
                                                "right",
                                                this.quill.root.offsetWidth -
                                                    parseInt(t.elem.style.left) <=
                                                    i.offsetWidth
                                            ),
                                        this.emit(e.events.CURSOR_MOVED, t)
                                    );
                                }),
                                e
                            );
                        })(i)),
                        o.registerModule("multi-cursor", r),
                        (e.exports = r));
                },
                { "../quill": 30, eventemitter2: 2 }
            ],
            26: [
                function (t, e, n) {
                    var i, r, o, s, l, u;
                    ((s = t("../quill")),
                        (r = t("../core/document")),
                        (u = s.require("lodash")),
                        (l = s.require("dom")),
                        (i = s.require("delta")),
                        (o = (function () {
                            function t(t, e) {
                                ((this.quill = t),
                                    (this.options = e),
                                    (this.container = this.quill.addContainer("ql-paste-manager")),
                                    this.container.setAttribute("contenteditable", !0),
                                    l(this.quill.root).on("paste", u.bind(this._paste, this)));
                            }
                            return (
                                (t.prototype._paste = function () {
                                    var t;
                                    if (
                                        (this.quill.getLength(),
                                        null != (t = this.quill.getSelection()))
                                    )
                                        return (
                                            this.container.focus(),
                                            u.defer(
                                                (function (e) {
                                                    return function () {
                                                        var n, o, s, l, u, a, c;
                                                        return (
                                                            (o = new r(e.container, e.quill.options)),
                                                            (n = o.toDelta()).ops.map(function (t) {
                                                                return ((t.attributes = null), t);
                                                            }),
                                                            (s = n.length() - 1),
                                                            n.compose(new i().retain(s).delete(1)),
                                                            t.start > 0 &&
                                                                n.ops.unshift({ retain: t.start }),
                                                            n.delete(t.end - t.start),
                                                            e.quill.updateContents(n, "user"),
                                                            e.quill.setSelection(
                                                                t.start + s,
                                                                t.start + s
                                                            ),
                                                            (c = e.quill.editor.doc.findLineAt(
                                                                t.start + s
                                                            )),
                                                            (l = c[0]),
                                                            c[1],
                                                            (u = l.node.getBoundingClientRect().bottom),
                                                            (a = document.documentElement.clientHeight),
                                                            u > a && l.node.scrollIntoView(!1),
                                                            (e.container.innerHTML = "")
                                                        );
                                                    };
                                                })(this)
                                            )
                                        );
                                }),
                                t
                            );
                        })()),
                        s.registerModule("paste-manager", o),
                        (e.exports = o));
                },
                { "../core/document": 8, "../quill": 30 }
            ],
            27: [
                function (t, e, n) {
                    var i, r, o, s;
                    ((i = t("../quill")),
                        (s = i.require("lodash")),
                        (o = i.require("dom")),
                        (r = (function () {
                            function t(e, n) {
                                if (
                                    ((this.quill = e),
                                    (this.options = n),
                                    (s.isString(this.options) || s.isElement(this.options)) &&
                                        (this.options = { container: this.options }),
                                    null == this.options.container)
                                )
                                    throw new Error("container required for toolbar", this.options);
                                ((this.container = s.isString(this.options.container)
                                    ? document.querySelector(this.options.container)
                                    : this.options.container),
                                    (this.inputs = {}),
                                    (this.preventUpdate = !1),
                                    (this.triggering = !1),
                                    s.each(
                                        this.quill.options.formats,
                                        (function (e) {
                                            return function (n) {
                                                if (null == t.formats.TOOLTIP[n])
                                                    return e.initFormat(n, function (i, r) {
                                                        if (!e.triggering)
                                                            return (
                                                                i.isCollapsed()
                                                                    ? e.quill.prepareFormat(n, r)
                                                                    : null != t.formats.LINE[n]
                                                                      ? e.quill.formatLine(
                                                                            i,
                                                                            n,
                                                                            r,
                                                                            "user"
                                                                        )
                                                                      : e.quill.formatText(
                                                                            i,
                                                                            n,
                                                                            r,
                                                                            "user"
                                                                        ),
                                                                s.defer(function () {
                                                                    return (
                                                                        e.updateActive(i, [
                                                                            "bullet",
                                                                            "list"
                                                                        ]),
                                                                        e.setActive(n, r)
                                                                    );
                                                                })
                                                            );
                                                    });
                                            };
                                        })(this)
                                    ),
                                    this.quill.on(
                                        this.quill.constructor.events.SELECTION_CHANGE,
                                        (function (t) {
                                            return function (e) {
                                                if (null != e) return t.updateActive(e);
                                            };
                                        })(this)
                                    ),
                                    this.quill.onModuleLoad(
                                        "keyboard",
                                        (function (t) {
                                            return function (e) {
                                                return e.addHotkey(
                                                    [o.KEYS.BACKSPACE, o.KEYS.DELETE, o.KEYS.ENTER],
                                                    function () {
                                                        return s.defer(s.bind(t.updateActive, t));
                                                    }
                                                );
                                            };
                                        })(this)
                                    ),
                                    o(this.container).addClass("ql-toolbar"),
                                    o.isIOS() && o(this.container).addClass("ios"),
                                    o.isIE(11) &&
                                        o(this.container).on("mousedown", function () {
                                            return !1;
                                        }));
                            }
                            return (
                                (t.DEFAULTS = { container: null }),
                                (t.formats = {
                                    LINE: { align: "align", bullet: "bullet", list: "list" },
                                    SELECT: {
                                        align: "align",
                                        background: "background",
                                        color: "color",
                                        font: "font",
                                        size: "size"
                                    },
                                    TOGGLE: {
                                        bold: "bold",
                                        bullet: "bullet",
                                        image: "image",
                                        italic: "italic",
                                        link: "link",
                                        list: "list",
                                        strike: "strike",
                                        underline: "underline"
                                    },
                                    TOOLTIP: { image: "image", link: "link" }
                                }),
                                (t.prototype.initFormat = function (e, n) {
                                    var i, r, s;
                                    if (
                                        ((s = ".ql-" + e),
                                        null != t.formats.SELECT[e]
                                            ? ((s = "select" + s), (i = "change"))
                                            : (i = "click"),
                                        null != (r = this.container.querySelector(s)))
                                    )
                                        return (
                                            (this.inputs[e] = r),
                                            o(r).on(
                                                i,
                                                (function (t) {
                                                    return function () {
                                                        var e, s;
                                                        return (
                                                            (s =
                                                                "change" === i
                                                                    ? o(r).value()
                                                                    : !o(r).hasClass("ql-active")),
                                                            (t.preventUpdate = !0),
                                                            t.quill.focus(),
                                                            null != (e = t.quill.getSelection()) &&
                                                                n(e, s),
                                                            (t.preventUpdate = !1),
                                                            !0
                                                        );
                                                    };
                                                })(this)
                                            )
                                        );
                                }),
                                (t.prototype.setActive = function (t, e) {
                                    var n, i, r, s;
                                    if (null != (i = this.inputs[t]))
                                        return (
                                            (n = o(i)),
                                            "SELECT" === i.tagName
                                                ? ((this.triggering = !0),
                                                  (r = n.value(i)),
                                                  null == e &&
                                                      (e =
                                                          null != (s = n.default()) ? s.value : void 0),
                                                  Array.isArray(e) && (e = ""),
                                                  e !== r && (null != e ? n.option(e) : n.reset()),
                                                  (this.triggering = !1))
                                                : n.toggleClass("ql-active", e || !1)
                                        );
                                }),
                                (t.prototype.updateActive = function (t, e) {
                                    var n;
                                    if (
                                        (null == e && (e = null),
                                        t || (t = this.quill.getSelection()),
                                        null != t && !this.preventUpdate)
                                    )
                                        return (
                                            (n = this._getActive(t)),
                                            s.each(
                                                this.inputs,
                                                (function (t) {
                                                    return function (i, r) {
                                                        return (
                                                            (!Array.isArray(e) || e.indexOf(r) > -1) &&
                                                                t.setActive(r, n[r]),
                                                            !0
                                                        );
                                                    };
                                                })(this)
                                            )
                                        );
                                }),
                                (t.prototype._getActive = function (t) {
                                    var e, n;
                                    return (
                                        (e = this._getLeafActive(t)),
                                        (n = this._getLineActive(t)),
                                        s.defaults({}, e, n)
                                    );
                                }),
                                (t.prototype._getLeafActive = function (t) {
                                    var e, n, i;
                                    return (
                                        t.isCollapsed()
                                            ? ((i = this.quill.editor.doc.findLineAt(t.start))[0],
                                              (e =
                                                  0 === i[1]
                                                      ? this.quill.getContents(t.start, t.end + 1)
                                                      : this.quill.getContents(t.start - 1, t.end)))
                                            : (e = this.quill.getContents(t)),
                                        (n = s.map(e.ops, "attributes")),
                                        this._intersectFormats(n)
                                    );
                                }),
                                (t.prototype._getLineActive = function (t) {
                                    var e, n, i, r, o;
                                    for (
                                        n = [],
                                            e = (r = this.quill.editor.doc.findLineAt(t.start))[0],
                                            r[1],
                                            i = (o = this.quill.editor.doc.findLineAt(t.end))[0],
                                            o[1],
                                            null != i && i === e && (i = i.next);
                                        null != e && e !== i;

                                    )
                                        (n.push(s.clone(e.formats)), (e = e.next));
                                    return this._intersectFormats(n);
                                }),
                                (t.prototype._intersectFormats = function (e) {
                                    return s.reduce(
                                        e.slice(1),
                                        function (e, n) {
                                            var i, r, o, l, u;
                                            return (
                                                (i = Object.keys(e)),
                                                (o = null != n ? Object.keys(n) : {}),
                                                (l = s.intersection(i, o)),
                                                (u = s.difference(i, o)),
                                                (r = s.difference(o, i)),
                                                s.each(l, function (i) {
                                                    if (null != t.formats.SELECT[i])
                                                        if (Array.isArray(e[i])) {
                                                            if (e[i].indexOf(n[i]) < 0)
                                                                return e[i].push(n[i]);
                                                        } else if (e[i] !== n[i])
                                                            return (e[i] = [e[i], n[i]]);
                                                }),
                                                s.each(u, function (n) {
                                                    return null != t.formats.TOGGLE[n]
                                                        ? delete e[n]
                                                        : null == t.formats.SELECT[n] ||
                                                            Array.isArray(e[n])
                                                          ? void 0
                                                          : (e[n] = [e[n]]);
                                                }),
                                                s.each(r, function (i) {
                                                    if (null != t.formats.SELECT[i])
                                                        return (e[i] = [n[i]]);
                                                }),
                                                e
                                            );
                                        },
                                        e[0] || {}
                                    );
                                }),
                                t
                            );
                        })()),
                        i.registerModule("toolbar", r),
                        (e.exports = r));
                },
                { "../quill": 30 }
            ],
            28: [
                function (t, e, n) {
                    var i, r, o, s, l;
                    ((r = t("../quill")),
                        (i = t("../lib/normalizer")),
                        (l = r.require("lodash")),
                        (s = r.require("dom")),
                        (o = (function () {
                            function t(e, n) {
                                ((this.quill = e),
                                    (this.options = n),
                                    (this.container = this.quill.addContainer("ql-tooltip")),
                                    (this.container.innerHTML = i.stripWhitespace(
                                        this.options.template
                                    )),
                                    s(this.quill.root).on("focus", l.bind(this.hide, this)),
                                    this.hide(),
                                    this.quill.on(
                                        this.quill.constructor.events.TEXT_CHANGE,
                                        (function (e) {
                                            return function (n, i) {
                                                if (
                                                    "user" === i &&
                                                    e.container.style.left !== t.HIDE_MARGIN
                                                )
                                                    return ((e.range = null), e.hide());
                                            };
                                        })(this)
                                    ));
                            }
                            return (
                                (t.DEFAULTS = { offset: 10, template: "" }),
                                (t.HIDE_MARGIN = "-10000px"),
                                (t.prototype.initTextbox = function (t, e, n) {
                                    return s(t).on(
                                        "keyup",
                                        (function (t) {
                                            return function (i) {
                                                switch (i.which) {
                                                    case s.KEYS.ENTER:
                                                        return e.call(t);
                                                    case s.KEYS.ESCAPE:
                                                        return n.call(t);
                                                    default:
                                                        return !0;
                                                }
                                            };
                                        })(this)
                                    );
                                }),
                                (t.prototype.hide = function () {
                                    return (
                                        (this.container.style.left = t.HIDE_MARGIN),
                                        this.range && this.quill.setSelection(this.range),
                                        (this.range = null)
                                    );
                                }),
                                (t.prototype.position = function (t) {
                                    var e, n, i, r, o, s;
                                    return (
                                        null != t
                                            ? ((o = t.getBoundingClientRect()),
                                              (r = this.quill.container.getBoundingClientRect()),
                                              (n = o.left - r.left),
                                              (i = o.top - r.top),
                                              o.bottom - r.bottom,
                                              (e = n + o.width / 2 - this.container.offsetWidth / 2),
                                              (s = i + o.height + this.options.offset) +
                                                  this.container.offsetHeight >
                                                  this.quill.container.offsetHeight &&
                                                  (s =
                                                      i -
                                                      this.container.offsetHeight -
                                                      this.options.offset),
                                              (e = Math.max(
                                                  0,
                                                  Math.min(
                                                      e,
                                                      this.quill.container.offsetWidth -
                                                          this.container.offsetWidth
                                                  )
                                              )),
                                              (s = Math.max(
                                                  0,
                                                  Math.min(
                                                      s,
                                                      this.quill.container.offsetHeight -
                                                          this.container.offsetHeight
                                                  )
                                              )))
                                            : ((e =
                                                  this.quill.container.offsetWidth / 2 -
                                                  this.container.offsetWidth / 2),
                                              (s =
                                                  this.quill.container.offsetHeight / 2 -
                                                  this.container.offsetHeight / 2)),
                                        (s += this.quill.container.scrollTop),
                                        [e, s]
                                    );
                                }),
                                (t.prototype.show = function (t) {
                                    var e, n, i;
                                    return (
                                        (this.range = this.quill.getSelection()),
                                        (i = this.position(t)),
                                        (e = i[0]),
                                        (n = i[1]),
                                        (this.container.style.left = e + "px"),
                                        (this.container.style.top = n + "px"),
                                        this.container.focus()
                                    );
                                }),
                                t
                            );
                        })()),
                        r.registerModule("tooltip", o),
                        (e.exports = o));
                },
                { "../lib/normalizer": 18, "../quill": 30 }
            ],
            29: [
                function (t, e, n) {
                    var i, r, o;
                    ((i = t("../quill")),
                        (o = i.require("lodash")),
                        i.require("delta"),
                        (r = (function () {
                            function t(t, e) {
                                ((this.quill = t),
                                    (this.options = null != e ? e : {}),
                                    (this.lastRecorded = 0),
                                    (this.ignoreChange = !1),
                                    this.clear(),
                                    this.initListeners());
                            }
                            return (
                                (t.DEFAULTS = { delay: 1e3, maxStack: 100 }),
                                (t.hotkeys = {
                                    UNDO: { key: "Z", metaKey: !0 },
                                    REDO: { key: "Z", metaKey: !0, shiftKey: !0 }
                                }),
                                (t.prototype.initListeners = function () {
                                    return (
                                        this.quill.onModuleLoad(
                                            "keyboard",
                                            (function (e) {
                                                return function (n) {
                                                    return (
                                                        n.addHotkey(t.hotkeys.UNDO, function () {
                                                            return (
                                                                e.quill.editor.checkUpdate(),
                                                                e.undo(),
                                                                !1
                                                            );
                                                        }),
                                                        n.addHotkey(t.hotkeys.REDO, function () {
                                                            return (
                                                                e.quill.editor.checkUpdate(),
                                                                e.redo(),
                                                                !1
                                                            );
                                                        })
                                                    );
                                                };
                                            })(this)
                                        ),
                                        this.quill.on(
                                            this.quill.constructor.events.TEXT_CHANGE,
                                            (function (t) {
                                                return function (e, n) {
                                                    if (!t.ignoreChange)
                                                        return (
                                                            t.record(e, t.oldDelta),
                                                            (t.oldDelta = t.quill.getContents())
                                                        );
                                                };
                                            })(this)
                                        )
                                    );
                                }),
                                (t.prototype.clear = function () {
                                    return (
                                        (this.stack = { undo: [], redo: [] }),
                                        (this.oldDelta = this.quill.getContents())
                                    );
                                }),
                                (t.prototype.record = function (t, e) {
                                    var n, i, r;
                                    if (t.ops.length > 0) {
                                        this.stack.redo = [];
                                        try {
                                            if (
                                                ((r = this.quill.getContents().diff(this.oldDelta)),
                                                (i = new Date().getTime()),
                                                this.lastRecorded + this.options.delay > i &&
                                                this.stack.undo.length > 0
                                                    ? ((n = this.stack.undo.pop()),
                                                      (r = r.compose(n.undo)),
                                                      (t = n.redo.compose(t)))
                                                    : (this.lastRecorded = i),
                                                this.stack.undo.push({ redo: t, undo: r }),
                                                this.stack.undo.length > this.options.maxStack)
                                            )
                                                return this.stack.undo.unshift();
                                        } catch (t) {
                                            return (
                                                t,
                                                console.warn(
                                                    "Could not record change... clearing undo stack."
                                                ),
                                                this.clear()
                                            );
                                        }
                                    }
                                }),
                                (t.prototype.redo = function () {
                                    return this._change("redo", "undo");
                                }),
                                (t.prototype.undo = function () {
                                    return this._change("undo", "redo");
                                }),
                                (t.prototype._getLastChangeIndex = function (t) {
                                    var e, n;
                                    return (
                                        (n = 0),
                                        (e = 0),
                                        o.each(t.ops, function (t) {
                                            return null != t.insert
                                                ? (n = Math.max(e + (t.insert.length || 1), n))
                                                : null != t.delete
                                                  ? (n = Math.max(e, n))
                                                  : null != t.retain
                                                    ? (null != t.attributes &&
                                                          (n = Math.max(e + t.retain, n)),
                                                      (e += t.retain))
                                                    : void 0;
                                        }),
                                        n
                                    );
                                }),
                                (t.prototype._change = function (t, e) {
                                    var n, i;
                                    if (this.stack[t].length > 0)
                                        return (
                                            (n = this.stack[t].pop()),
                                            (this.lastRecorded = 0),
                                            (this.ignoreChange = !0),
                                            this.quill.updateContents(n[t], "user"),
                                            (this.ignoreChange = !1),
                                            (i = this._getLastChangeIndex(n[t])),
                                            this.quill.setSelection(i, i),
                                            (this.oldDelta = this.quill.getContents()),
                                            this.stack[e].push(n)
                                        );
                                }),
                                t
                            );
                        })()),
                        i.registerModule("undo-manager", r),
                        (e.exports = r));
                },
                { "../quill": 30 }
            ],
            30: [
                function (t, e, n) {
                    var i,
                        r,
                        o,
                        s,
                        l,
                        u,
                        a,
                        c,
                        h,
                        f = {}.hasOwnProperty,
                        p = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) f.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        },
                        d = [].slice;
                    ((h = t("lodash")),
                        (c = t("../package.json")),
                        (i = t("rich-text/lib/delta")),
                        (o = t("eventemitter2").EventEmitter2),
                        (a = t("./lib/dom")),
                        (r = t("./core/editor")),
                        (s = t("./core/format")),
                        (u = t("./lib/range")),
                        (l = (function (t) {
                            function e(t, n) {
                                var i, o, s;
                                if (
                                    ((this.container = t),
                                    null == n && (n = {}),
                                    h.isString(this.container) &&
                                        (this.container = document.querySelector(t)),
                                    null == this.container)
                                )
                                    throw new Error("Invalid Quill container");
                                if (
                                    ((o = h.defaults(n.modules || {}, e.DEFAULTS.modules)),
                                    (i = this.container.innerHTML),
                                    (this.container.innerHTML = ""),
                                    (this.options = h.defaults(n, e.DEFAULTS)),
                                    (this.options.modules = o),
                                    (this.options.id = this.id = "ql-editor-" + (e.editors.length + 1)),
                                    (this.options.emitter = this),
                                    (this.modules = {}),
                                    (this.root = this.addContainer("ql-editor")),
                                    (this.editor = new r(this.root, this, this.options)),
                                    e.editors.push(this),
                                    this.setHTML(i, e.sources.SILENT),
                                    null == (s = e.themes[this.options.theme]))
                                )
                                    throw new Error(
                                        "Cannot load " +
                                            this.options.theme +
                                            " theme. Are you sure you registered it?"
                                    );
                                ((this.theme = new s(this, this.options)),
                                    h.each(
                                        this.options.modules,
                                        (function (t) {
                                            return function (e, n) {
                                                return t.addModule(n, e);
                                            };
                                        })(this)
                                    ));
                            }
                            return (
                                p(e, t),
                                (e.version = c.version),
                                (e.editors = []),
                                (e.modules = []),
                                (e.themes = []),
                                (e.DEFAULTS = {
                                    formats: [
                                        "align",
                                        "bold",
                                        "italic",
                                        "strike",
                                        "underline",
                                        "color",
                                        "background",
                                        "font",
                                        "size",
                                        "link",
                                        "image",
                                        "bullet",
                                        "list"
                                    ],
                                    modules: { keyboard: !0, "paste-manager": !0, "undo-manager": !0 },
                                    pollInterval: 100,
                                    readOnly: !1,
                                    styles: {},
                                    theme: "base"
                                }),
                                (e.events = {
                                    MODULE_INIT: "module-init",
                                    POST_EVENT: "post-event",
                                    PRE_EVENT: "pre-event",
                                    SELECTION_CHANGE: "selection-change",
                                    TEXT_CHANGE: "text-change"
                                }),
                                (e.sources = r.sources),
                                (e.registerModule = function (t, n) {
                                    return (
                                        null != e.modules[t] &&
                                            console.warn("Overwriting " + t + " module"),
                                        (e.modules[t] = n)
                                    );
                                }),
                                (e.registerTheme = function (t, n) {
                                    return (
                                        null != e.themes[t] &&
                                            console.warn("Overwriting " + t + " theme"),
                                        (e.themes[t] = n)
                                    );
                                }),
                                (e.require = function (t) {
                                    switch (t) {
                                        case "lodash":
                                            return h;
                                        case "delta":
                                            return i;
                                        case "dom":
                                            return a;
                                        default:
                                            return null;
                                    }
                                }),
                                (e.prototype.destroy = function () {
                                    var t;
                                    return (
                                        (t = this.getHTML()),
                                        h.each(this.modules, function (t, e) {
                                            if (h.isFunction(t.destroy)) return t.destroy();
                                        }),
                                        this.editor.destroy(),
                                        this.removeAllListeners(),
                                        e.editors.splice(h.indexOf(e.editors, this), 1),
                                        (this.container.innerHTML = t)
                                    );
                                }),
                                (e.prototype.addContainer = function (t, e) {
                                    var n, i;
                                    return (
                                        null == e && (e = !1),
                                        (i = e ? this.root : null),
                                        (n = document.createElement("div")),
                                        a(n).addClass(t),
                                        this.container.insertBefore(n, i),
                                        n
                                    );
                                }),
                                (e.prototype.addFormat = function (t, e) {
                                    return this.editor.doc.addFormat(t, e);
                                }),
                                (e.prototype.addModule = function (t, n) {
                                    var i;
                                    if (null == (i = e.modules[t]))
                                        throw new Error(
                                            "Cannot load " +
                                                t +
                                                " module. Are you sure you registered it?"
                                        );
                                    return (
                                        !0 === n && (n = {}),
                                        (n = h.defaults(
                                            n,
                                            this.theme.constructor.OPTIONS[t] || {},
                                            i.DEFAULTS || {}
                                        )),
                                        (this.modules[t] = new i(this, n)),
                                        this.emit(e.events.MODULE_INIT, t, this.modules[t]),
                                        this.modules[t]
                                    );
                                }),
                                (e.prototype.deleteText = function (t, n, r) {
                                    var o, s;
                                    if (
                                        (null == r && (r = e.sources.API),
                                        (s = this._buildParams(t, n, {}, r)),
                                        (t = s[0]),
                                        (n = s[1]),
                                        s[2],
                                        (r = s[3]),
                                        n > t)
                                    )
                                        return (
                                            (o = new i().retain(t).delete(n - t)),
                                            this.editor.applyDelta(o, r)
                                        );
                                }),
                                (e.prototype.emit = function () {
                                    var t, n;
                                    return (
                                        (n = arguments[0]),
                                        (t = 2 <= arguments.length ? d.call(arguments, 1) : []),
                                        e.__super__.emit.apply(
                                            this,
                                            [e.events.PRE_EVENT, n].concat(d.call(t))
                                        ),
                                        e.__super__.emit.apply(this, [n].concat(d.call(t))),
                                        e.__super__.emit.apply(
                                            this,
                                            [e.events.POST_EVENT, n].concat(d.call(t))
                                        )
                                    );
                                }),
                                (e.prototype.focus = function () {
                                    return this.editor.focus();
                                }),
                                (e.prototype.formatLine = function (t, e, n, i, r) {
                                    var o, s, l, u, a;
                                    return (
                                        (u = this._buildParams(t, e, n, i, r)),
                                        (t = u[0]),
                                        (e = u[1]),
                                        (o = u[2]),
                                        (r = u[3]),
                                        (a = this.editor.doc.findLineAt(e)),
                                        (s = a[0]),
                                        (l = a[1]),
                                        null != s && (e += s.length - l),
                                        this.formatText(t, e, o, r)
                                    );
                                }),
                                (e.prototype.formatText = function (t, e, n, r, o) {
                                    var s, l, u;
                                    return (
                                        (u = this._buildParams(t, e, n, r, o)),
                                        (t = u[0]),
                                        (e = u[1]),
                                        (l = u[2]),
                                        (o = u[3]),
                                        (l = h.reduce(
                                            l,
                                            (function (t) {
                                                return function (e, n, i) {
                                                    var r;
                                                    return (
                                                        (r = t.editor.doc.formats[i]),
                                                        (n && n !== r.config.default) || (e[i] = null),
                                                        e
                                                    );
                                                };
                                            })(this),
                                            l
                                        )),
                                        (s = new i().retain(t).retain(e - t, l)),
                                        this.editor.applyDelta(s, o)
                                    );
                                }),
                                (e.prototype.getBounds = function (t) {
                                    return this.editor.getBounds(t);
                                }),
                                (e.prototype.getContents = function (t, e) {
                                    return (
                                        null == t && (t = 0),
                                        null == e && (e = null),
                                        h.isObject(t) && ((e = t.end), (t = t.start)),
                                        this.editor.getDelta().slice(t, e)
                                    );
                                }),
                                (e.prototype.getHTML = function () {
                                    return this.editor.doc.getHTML();
                                }),
                                (e.prototype.getLength = function () {
                                    return this.editor.getDelta().length();
                                }),
                                (e.prototype.getModule = function (t) {
                                    return this.modules[t];
                                }),
                                (e.prototype.getSelection = function () {
                                    return (
                                        this.editor.checkUpdate(),
                                        this.editor.selection.getRange()
                                    );
                                }),
                                (e.prototype.getText = function (t, e) {
                                    return (
                                        null == t && (t = 0),
                                        null == e && (e = null),
                                        h
                                            .map(this.getContents(t, e).ops, function (t) {
                                                return h.isString(t.insert) ? t.insert : "";
                                            })
                                            .join("")
                                    );
                                }),
                                (e.prototype.insertEmbed = function (t, e, n, i) {
                                    return this.insertText(t, a.EMBED_TEXT, e, n, i);
                                }),
                                (e.prototype.insertText = function (t, e, n, r, o) {
                                    var s, l, u;
                                    if (
                                        ((u = this._buildParams(t, 0, n, r, o)),
                                        (t = u[0]),
                                        u[1],
                                        (l = u[2]),
                                        (o = u[3]),
                                        e.length > 0)
                                    )
                                        return (
                                            (s = new i().retain(t).insert(e, l)),
                                            this.editor.applyDelta(s, o)
                                        );
                                }),
                                (e.prototype.onModuleLoad = function (t, n) {
                                    return this.modules[t]
                                        ? n(this.modules[t])
                                        : this.on(e.events.MODULE_INIT, function (e, i) {
                                              if (e === t) return n(i);
                                          });
                                }),
                                (e.prototype.prepareFormat = function (t, n) {
                                    var i, r;
                                    if (
                                        null != (i = this.editor.doc.formats[t]) &&
                                        ((r = this.getSelection()),
                                        null != r ? r.isCollapsed() : void 0)
                                    )
                                        return i.isType(s.types.LINE)
                                            ? this.formatLine(r, t, n, e.sources.USER)
                                            : i.prepare(n);
                                }),
                                (e.prototype.setContents = function (t, n) {
                                    return (
                                        null == n && (n = e.sources.API),
                                        (t = Array.isArray(t)
                                            ? { ops: t.slice() }
                                            : { ops: t.ops.slice() }).ops.push({
                                            delete: this.getLength()
                                        }),
                                        this.updateContents(t, n)
                                    );
                                }),
                                (e.prototype.setHTML = function (t, n) {
                                    return (
                                        null == n && (n = e.sources.API),
                                        t.trim() ||
                                            (t =
                                                "<" +
                                                a.DEFAULT_BLOCK_TAG +
                                                "><" +
                                                a.DEFAULT_BREAK_TAG +
                                                "></" +
                                                a.DEFAULT_BLOCK_TAG +
                                                ">"),
                                        this.editor.doc.setHTML(t),
                                        this.editor.checkUpdate(n)
                                    );
                                }),
                                (e.prototype.setSelection = function (t, n, i) {
                                    var r;
                                    return (
                                        null == i && (i = e.sources.API),
                                        h.isNumber(t) && h.isNumber(n)
                                            ? (r = new u(t, n))
                                            : ((r = t), (i = n || i)),
                                        this.editor.selection.setRange(r, i)
                                    );
                                }),
                                (e.prototype.setText = function (t, n) {
                                    var r;
                                    return (
                                        null == n && (n = e.sources.API),
                                        (r = new i().insert(t)),
                                        this.setContents(r, n)
                                    );
                                }),
                                (e.prototype.updateContents = function (t, n) {
                                    return (
                                        null == n && (n = e.sources.API),
                                        this.editor.applyDelta(t, n)
                                    );
                                }),
                                (e.prototype._buildParams = function () {
                                    var t, n;
                                    return (
                                        (n = 1 <= arguments.length ? d.call(arguments, 0) : []),
                                        h.isObject(n[0]) && n.splice(0, 1, n[0].start, n[0].end),
                                        h.isString(n[2]) &&
                                            (((t = {})[n[2]] = n[3]), n.splice(2, 2, t)),
                                        null == n[3] && (n[3] = e.sources.API),
                                        n
                                    );
                                }),
                                e
                            );
                        })(o)).registerTheme("base", t("./themes/base")),
                        l.registerTheme("snow", t("./themes/snow")),
                        (e.exports = l));
                },
                {
                    "../package.json": 7,
                    "./core/editor": 9,
                    "./core/format": 10,
                    "./lib/dom": 16,
                    "./lib/range": 20,
                    "./themes/base": 32,
                    "./themes/snow": 33,
                    eventemitter2: 2,
                    lodash: 1,
                    "rich-text/lib/delta": 3
                }
            ],
            31: [
                function (t, e, n) {
                    e.exports =
                        '.ql-image-tooltip{padding:10px;width:300px}.ql-image-tooltip:after{clear:both;content:"";display:table}.ql-image-tooltip a{border:1px solid #000;box-sizing:border-box;display:inline-block;float:left;padding:5px;text-align:center;width:50%}.ql-image-tooltip img{bottom:0;left:0;margin:auto;max-height:100%;max-width:100%;position:absolute;right:0;top:0}.ql-image-tooltip .input{box-sizing:border-box;width:100%}.ql-image-tooltip .preview{margin:10px 0;position:relative;border:1px dashed #000;height:200px}.ql-image-tooltip .preview span{display:inline-block;position:absolute;text-align:center;top:40%;width:100%}.ql-link-tooltip{padding:5px 10px}.ql-link-tooltip input.input{width:170px}.ql-link-tooltip a.done,.ql-link-tooltip input.input{display:none}.ql-link-tooltip.editing a.done,.ql-link-tooltip.editing input.input{display:inline-block}.ql-link-tooltip.editing a.change,.ql-link-tooltip.editing a.url{display:none}.ql-multi-cursor{position:absolute;left:0;top:0;z-index:1000}.ql-multi-cursor .cursor{margin-left:-1px;position:absolute}.ql-multi-cursor .cursor-flag{bottom:100%;position:absolute;white-space:nowrap}.ql-multi-cursor .cursor-name{display:inline-block;color:#fff;padding:2px 8px}.ql-multi-cursor .cursor-caret{height:100%;position:absolute;width:2px}.ql-multi-cursor .cursor.hidden .cursor-flag{display:none}.ql-multi-cursor .cursor.top .cursor-flag{bottom:auto;top:100%}.ql-multi-cursor .cursor.right .cursor-flag{right:-2px}.ql-paste-manager{left:-100000px;position:absolute;top:50%}.ql-toolbar{box-sizing:border-box}.ql-tooltip{background-color:#fff;border:1px solid #000;box-sizing:border-box;position:absolute;top:0;white-space:nowrap;z-index:2000}.ql-tooltip a{cursor:pointer;text-decoration:none}.ql-container{box-sizing:border-box;cursor:text;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;line-height:1.42;margin:0;overflow-x:hidden;overflow-y:auto;padding:12px 15px;position:relative}.ql-editor{box-sizing:border-box;min-height:100%;outline:0;tab-size:4;white-space:pre-wrap}.ql-editor div{margin:0;padding:0}.ql-editor a{text-decoration:underline}.ql-editor b{font-weight:700}.ql-editor i{font-style:italic}.ql-editor s{text-decoration:line-through}.ql-editor u{text-decoration:underline}.ql-editor img{max-width:100%}.ql-editor blockquote,.ql-editor ol,.ql-editor ul{margin:0 0 0 2em;padding:0}.ql-editor ol{list-style-type:decimal}.ql-editor ul{list-style-type:disc}.ql-editor.ql-ie-10 br,.ql-editor.ql-ie-9 br{display:none}';
                },
                {}
            ],
            32: [
                function (t, e, n) {
                    var i, r, o, s;
                    ((s = t("lodash")),
                        (o = t("../../lib/dom")),
                        (r = t("./base.styl")),
                        (i = (function () {
                            function t(e, n) {
                                var i;
                                ((this.quill = e),
                                    (this.options = n),
                                    o(this.quill.container).addClass("ql-container"),
                                    this.options.styles &&
                                        this.addStyles(r + t.objToCss(this.options.styles)),
                                    o.isIE(10) &&
                                        ((i = o.isIE(9) ? "9" : "10"),
                                        o(this.quill.root).addClass("ql-ie-" + i)));
                            }
                            return (
                                (t.OPTIONS = {}),
                                (t.objToCss = function (t) {
                                    return s
                                        .map(t, function (t, e) {
                                            var n;
                                            return (
                                                (n = s
                                                    .map(t, function (t, e) {
                                                        return e + ": " + t + ";";
                                                    })
                                                    .join(" ")),
                                                e + " { " + n + " }"
                                            );
                                        })
                                        .join("\n");
                                }),
                                (t.prototype.addStyles = function (e) {
                                    var n;
                                    return (
                                        s.isObject(e) && (e = t.objToCss(e)),
                                        (n = document.createElement("style")),
                                        (n.type = "text/css"),
                                        n.appendChild(document.createTextNode(e)),
                                        document.head.appendChild(n)
                                    );
                                }),
                                t
                            );
                        })()),
                        (e.exports = i));
                },
                { "../../lib/dom": 16, "./base.styl": 31, lodash: 1 }
            ],
            33: [
                function (t, e, n) {
                    var i,
                        r,
                        o,
                        s,
                        l,
                        u,
                        a = {}.hasOwnProperty,
                        c = function (t, e) {
                            function n() {
                                this.constructor = t;
                            }
                            for (var i in e) a.call(e, i) && (t[i] = e[i]);
                            return (
                                (n.prototype = e.prototype),
                                (t.prototype = new n()),
                                (t.__super__ = e.prototype),
                                t
                            );
                        };
                    ((u = t("lodash")),
                        (r = t("../../lib/color-picker")),
                        (i = t("../base")),
                        (l = t("../../lib/dom")),
                        (o = t("../../lib/picker")),
                        (s = (function (t) {
                            function e(t, n) {
                                ((this.quill = t),
                                    (this.options = n),
                                    e.__super__.constructor.apply(this, arguments),
                                    l(this.quill.container).addClass("ql-snow"),
                                    (this.pickers = []),
                                    this.quill.on(
                                        this.quill.constructor.events.SELECTION_CHANGE,
                                        (function (t) {
                                            return function (e) {
                                                if (null != e) return u.invoke(t.pickers, "close");
                                            };
                                        })(this)
                                    ),
                                    this.quill.onModuleLoad(
                                        "multi-cursor",
                                        u.bind(this.extendMultiCursor, this)
                                    ),
                                    this.quill.onModuleLoad(
                                        "toolbar",
                                        u.bind(this.extendToolbar, this)
                                    ));
                            }
                            return (
                                c(e, t),
                                (e.COLORS = [
                                    "#000000",
                                    "#e60000",
                                    "#ff9900",
                                    "#ffff00",
                                    "#008A00",
                                    "#0066cc",
                                    "#9933ff",
                                    "#ffffff",
                                    "#facccc",
                                    "#ffebcc",
                                    "#ffffcc",
                                    "#cce8cc",
                                    "#cce0f5",
                                    "#ebd6ff",
                                    "#bbbbbb",
                                    "#f06666",
                                    "#ffc266",
                                    "#ffff66",
                                    "#66b966",
                                    "#66a3e0",
                                    "#c285ff",
                                    "#888888",
                                    "#a10000",
                                    "#b26b00",
                                    "#b2b200",
                                    "#006100",
                                    "#0047b2",
                                    "#6b24b2",
                                    "#444444",
                                    "#5c0000",
                                    "#663d00",
                                    "#666600",
                                    "#003700",
                                    "#002966",
                                    "#3d1466"
                                ]),
                                (e.OPTIONS = {
                                    "multi-cursor": {
                                        template:
                                            '<span class="cursor-flag"> <span class="cursor-triangle top"></span> <span class="cursor-name"></span> <span class="cursor-triangle bottom"></span> </span> <span class="cursor-caret"></span>'
                                    }
                                }),
                                (e.prototype.extendMultiCursor = function (t) {
                                    return t.on(t.constructor.events.CURSOR_ADDED, function (t) {
                                        var e, n;
                                        return (
                                            (e = t.elem.querySelector(".cursor-triangle.bottom")),
                                            (n = t.elem.querySelector(".cursor-triangle.top")),
                                            (e.style.borderTopColor = n.style.borderBottomColor =
                                                t.color)
                                        );
                                    });
                                }),
                                (e.prototype.extendToolbar = function (t) {
                                    return (
                                        l(t.container).addClass("ql-snow"),
                                        u.each(
                                            ["color", "background", "font", "size", "align"],
                                            (function (e) {
                                                return function (n) {
                                                    var i, s;
                                                    if (
                                                        null !=
                                                        (s = t.container.querySelector(".ql-" + n))
                                                    ) {
                                                        switch (n) {
                                                            case "font":
                                                            case "size":
                                                            case "align":
                                                                i = new o(s);
                                                                break;
                                                            case "color":
                                                            case "background":
                                                                ((i = new r(s)),
                                                                    u.each(
                                                                        i.container.querySelectorAll(
                                                                            ".ql-picker-item"
                                                                        ),
                                                                        function (t, e) {
                                                                            if (e < 7)
                                                                                return l(t).addClass(
                                                                                    "ql-primary-color"
                                                                                );
                                                                        }
                                                                    ));
                                                        }
                                                        return null != i ? e.pickers.push(i) : void 0;
                                                    }
                                                };
                                            })(this)
                                        ),
                                        u.each(l(t.container).textNodes(), function (t) {
                                            if (0 === l(t).text().trim().length) return l(t).remove();
                                        })
                                    );
                                }),
                                e
                            );
                        })(i)),
                        (e.exports = s));
                },
                {
                    "../../lib/color-picker": 15,
                    "../../lib/dom": 16,
                    "../../lib/picker": 19,
                    "../base": 32,
                    lodash: 1
                }
            ]
        },
        {},
        [14]
    )(14);
});
